import { BundleService } from "src/app/Services/bundleservice.service";
import { ShowFlowImageDialogComponent } from "./../show-flow-image-dialog/show-flow-image-dialog.component";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { DialogExampleComponent } from "./../../dialog-example/dialog-example.component";
import {
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Optional,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { ActivatedRoute, Router, ParamMap } from "@angular/router";
import { DataService } from "src/app/Services/dataservice.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
  FormControlName,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { FlowNavigationService } from "src/app/Services/flow-navigation.service";
import { writeGuideEditStorage } from "src/app/shared/utils/guide-edit-storage.util";

// import { ToastrService } from "ngx-toastr";
import { TitleandmetaserviceService } from "src/app/Services/titleandmetaservice.service";
import { EmbededComponent, ShareEmbedDialogData } from "../embeded/embeded.component";
import {
  buildEmbedContextFromFlowState,
  EmbedViewType,
} from "src/app/utils/embed.util";
import { CommentComponent } from "../comment/comment.component";
import { QRCodeComponent } from "../qrcode/qrcode.component";
import { EditCommentComponent } from "../edit-comment/edit-comment.component";
import { InAppropriateComponent } from "../in-appropriate/in-appropriate.component";
import { SupportDocumentComponent } from "../support-document/support-document.component";
import { RestrictedAccessComponent } from "../restricted-access/restricted-access.component";
import { EnhancedRestrictedAccessComponent } from "../enhanced-restricted-access/enhanced-restricted-access.component";
import { FlowAccessRequestComponent } from "../flow-access-request/flow-access-request.component";
import { FlowAccessBlockerComponent } from "../flow-access-blocker/flow-access-blocker.component";
import { PageTimeTrackerService } from "src/app/Services/page-time-tracker-service.service";
import { FlowQueryModel, UserQueryModel } from "src/app/models/flowquerymodel";
import { ToastrService } from "ngx-toastr";
import {
  getCurrentPositionOptional,
  getOrCreateDeviceId,
  getCachedGeoPosition,
  accessBlockTypeFromDenial,
  denialFromHttpError,
  shouldRetryAccessWithLocation,
  peekPendingFlowAccessRequest,
  clearPendingFlowAccessRequest,
} from "src/app/shared/utils/device-access.util";
import { catchError, take, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { forkJoin, of, Subject, Subscription } from "rxjs";
import { OrgContextService } from "src/app/Services/org-context.service";
import { ContentActivityPanelComponent } from "../content-activity-panel/content-activity-panel.component";
import { SupportFaqComponent } from "../support-faqs/support-faqs.component";
import { CheckoutNavigatorComponent } from "../checkout-navigator/checkout-navigator.component";
import { TransferOwnershipComponent } from "../transfer-ownership/transfer-ownership.component";
import { hasContentCreationPlanAccess } from "src/app/shared/utils/plan.util";
import { ItemDetailsDialogComponent } from "../item-details-dialog/item-details-dialog.component";
import { BundleTransferWarningDialogComponent } from "../bundle-transfer-warning-dialog/bundle-transfer-warning-dialog.component";
import { ConfirmBundleRemovalDialogComponent } from "../confirm-bundle-removal-dialog/confirm-bundle-removal-dialog.component";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import { TranslationService } from "src/app/Services/translation.service";
import { FlowReviewSubmitComponent } from "../flow-review-submit/flow-review-submit.component";
import { FlowCompletionConfirmationComponent } from "../flow-completion-confirmation/flow-completion-confirmation.component";
import { FlowIssueCheckComponent } from "../flow-issue-check/flow-issue-check.component";
import { FlowStepIssuesComponent } from "../flow-step-issues/flow-step-issues.component";
import { FlowThankYouComponent } from "../flow-thank-you/flow-thank-you.component";
import { FlowReviewsListModalComponent } from "../flow-reviews-list-modal/flow-reviews-list-modal.component";
import { FlowIssuesDialogComponent } from "../flow-issues-dialog/flow-issues-dialog.component";
import { ReportReviewDialogComponent } from "../report-review-dialog/report-review-dialog.component";
import { VersionHistoryPanelComponent } from "../version-history-panel/version-history-panel.component";
import { VersioningService } from "src/app/Services/versioning.service";
import { ScheduleViewDialogComponent } from "../schedule-view-dialog/schedule-view-dialog.component";
import { AnalyticsComponent } from "../analyics/analytics.component";
import { FrontlineFeatureFlags } from "src/app/shared/constants/frontline-glossary";
import {
  GUIDE_END_FORM_KEY,
  GuideQuestionForm,
  isGuideQuestionFormActive,
  newQuestionId,
  parseGuideQuestionForm,
} from "src/app/models/guide-question-form.model";
import { GuideQuestionFormDialogComponent } from "src/app/shared/guide-questions/guide-question-form-dialog.component";
@Component({
  selector: "app-viewflow",
  templateUrl: "./viewflow.component.html",
  styleUrls: ["./viewflow.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewflowComponent implements OnInit, OnDestroy, AfterViewInit {
  /** Soft-gate paid purchase CTAs for frontline Keep delivery. */
  readonly showContentPurchase = FrontlineFeatureFlags.showContentPurchase;

  userDisplayEmail: any;
  isPurchaseRequired: any;
  notFlowOwner: any;
  duration: any;
  totalTimeSpent: number;
  private pageStartTime: number;
  likeCount: any;
  saveCount: any;
  faqData: any;
  supportFlowFaqs: any;
  groupedFaqs: { groupName: string; faqs: any }[];
  isFlowPaid: boolean;
  allFaqs: any[];
  showFaq: boolean;
  isInitialLoading: boolean = true; // skeleton loader control
  flowCreatorData: any;
  defaultViewToggle: string;
  expandedGroups: { [key: string]: boolean } = {}; // Store expanded state
  searchKeywords: any[] = [];
  showAll: boolean = false;
  touchEndX: number;
  startY: number;
  endY: number;
  isToggled: boolean = false;
  coverPage: boolean = true;
  private isAccessDialogOpen: boolean = false;
  private isEnhancedDialogOpen: boolean = false;
  private geoAccessRetryUsed = false;
  selectedStepIndex = -2; // Default first step
  steps: any[] = [];
  noResultReturned: boolean;
  faqSelection: boolean = false;
  comment: string;
  reply: string;
  comments = [];
  name: string;
  replyForm: UntypedFormGroup;
  previousComment = [];
  showNotificationCount: boolean;
  notificationCount: number;
  email: string;
  website: string;
  phone: string;
  info: string;
  uname: string;
  profilePicture: string;
  stepText: string;
  userDisplayName: any;
  userData: any;
  flowData: any;
  showvideo: boolean;
  showimage: boolean;
  imageURI: any;
  videoURI: any;
  displayedColumns: string[] = ["position", "name"];
  dataSource = [];
  dataSourceSteps = [];
  showDefaultImage: boolean;
  visitedSteps: Set<number> = new Set(); // Track visited step indices
  bookmarkedSteps: Set<number> = new Set(); // Track bookmarked step indices
  // When true, completion percentage starts fresh on each visit instead of restoring previous progress
  // We want to show previously saved progress on load, so default is false.
  shouldResetStepProgressOnLoad: boolean = false;
  // Tracks if user has restarted the flow after completing it once
  hasRestartedAfterCompletion: boolean = false;
  commentsForm: UntypedFormGroup;
  imageSource: any;
  posterImageSource: any;
  description: any;
  currentStepTaggedItems: any[] = []; // Tagged items for current step
  nextCount: number;
  itemsRequired: number;
  currentImage: any;
  previousIndex: any;
  likecolor: any;
  viewsCount: any;
  viewText: any;
  followButtonText: string = "Follow";
  followingcolor: any;
  followingbgcolor: any;
  showFollow: boolean = true;
  isFollowLoading = false;
  isFirstSlide: any;
  isLastSlide: any;
  progressPercentage: number;
  progressBy: number;
  stepCount: number;
  bookmarkcolor: any;
  stepNumber: number;
  isMobileView: boolean;
  carouselOptions: any;
  showVideoOrImage: boolean;
  showMenu: boolean;
  isAutoplayEnabled: boolean = false;
  autoplayTooltipText =
    "Automatically advance to the next step when the current one ends.";
  showAutoplayMobileTooltip = false;
  private autoplayTimeout: any;
  private autoplayMobileTooltipTimeout: any;
  private autoplayVideoEndedHandler: any;
  private mutationObserver: MutationObserver | null = null;
  private resizeObserver: any = null;
  private alignmentDebounceTimeout: any = null;
  private isAligning: boolean = false;
  IsSteps: boolean;
  categories: any[] = [];
  videoPlayCounter: any = [];
  viewUnloaded: boolean;
  _steps: any = [];
  stepId: number;
  coverImageUri: string;
  title: string;
  inames: any[];
  flowId: any;
  CategoryName: string;
  tempFlows: any = [];
  embeddedInBlogs: any[] = [];
  bundles: any[] = [];
  isFlowHomePage: boolean;
  flowNotFound: boolean = false; // Indicates when the requested flow is not available
  homeslider = { items: 1, dots: true, nav: true };
  selectedGroup: any = null;
  selectedFaq: any = null;
  hasActiveTransferRequest: boolean = false; // Track if there are active transfer requests
  imageObject = [
    {},
    {
      image: "assets/images/002.jpg",
    },
    {
      image: "assets/images/003.jpg",
    },
  ];
  groupedData: Record<string, any[]> = {};
  question: string = "";
  conversationHistory: {
    question: string;
    answer: string;
    isGroupSelection: boolean;
  }[] = []; // Conversation history array
  isDivVisible: boolean = false; // Variable to toggle visibility
  isAnyDialogOpen: boolean = false; // Track if any MatDialog is open (for hiding chatbot)
  showDescriptionExpanded: boolean = false; // For description expand/collapse
  private chatInterruptedVideo = false;
  private readonly videoFileExtensions: string[] = [
    "mp4",
    "mov",
    "wmv",
    "flv",
    "avchd",
    "webm",
    "mkv",
    "vob",
    "ogv",
    "gifv",
    "m4p",
    "m4v",
    "3gp",
    "3g2",
    "amv",
    "nsv",
    "ogg",
    "f4v",
    "f4p",
    "f4a",
    "f4b",
    "avi",
    "mts",
    "m2ts",
    "ts",
    "mpg",
    "mpeg",
    "rm",
    "rmvb",
    "divx",
    "xvid",
    "asf",
    "mxf",
    "dv",
    "h264",
    "h265",
    "vp8",
    "vp9",
    "prores",
    "swf",
    "dat",
    "bik",
    "av1",
    "vro",
    "svi",
  ];

  @ViewChild("stepButtons") stepButtons!: ElementRef;
  @ViewChild("stepScrollContainer") stepScrollContainer!: ElementRef;
  @ViewChild("flowInfoPanel") flowInfoPanel!: ElementRef;
  @ViewChild("videoPlayerSection") videoPlayerSection!: ElementRef;
  @ViewChild("videoMetadata") videoMetadata!: ElementRef;
  @ViewChild("recommendationsSection") recommendationsSection!: ElementRef;
  @ViewChild("mobileCoverSection") mobileCoverSection?: ElementRef<HTMLElement>;
  @ViewChild("mobileItemsSection") mobileItemsSection?: ElementRef<HTMLElement>;
  @ViewChild("videoPlayer") videoPlayer!: ElementRef<HTMLVideoElement>;
  @ViewChildren("mobileStepSection")
  mobileStepSections?: QueryList<ElementRef<HTMLElement>>;
  flowReviews: any;
  // Cached computed values for reviews to avoid recalculating on every change detection
  private _cachedAverageRating: number = 0;
  private _cachedTotalReviews: number = 0;
  private _cachedRatingPercentages: { [key: number]: number } = {};
  private _cachedTopReviews: any[] = [];
  private _reviewsCacheValid: boolean = false;
  hasUserReviewed: boolean;
  
  // Public cached properties for template binding (updated when reviews change)
  public cachedAverageRating: number = 0;
  public cachedTotalReviews: number = 0;
  public cachedCustomersSaySummary: string = '';
  public cachedReviewsWithImages: any[] = [];
  public cachedTopReviews: any[] = [];
  isLoadingReviews: boolean = false;
  private reviewsProcessingSubject = new Subject<any[]>();

  // When opened inside version history preview dialog
  @Input() previewLogicalId?: string;
  @Input() previewVersion: number | null = null;
  @Input() openInDialog: boolean = false;
  embedMode = false;
  embedViewType: EmbedViewType = "full";
  private isApplyingEmbedView = false;
  private pendingEmbedView: EmbedViewType | null = null;
  private pendingEmbedStep: number | null = null;

  get showStandaloneExtras(): boolean {
    return !this.openInDialog && !this.embedMode;
  }

  /** Question forms answered (or skipped) in this viewing session, keyed by guide and form. */
  private answeredQuestionForms = new Set<string>();
  private questionDialogOpen = false;
  private readonly questionSessionId = newQuestionId();

  /** Forms are skipped in embeds, previews, review dialogs and for the guide's own author. */
  private get questionFormsEnabled(): boolean {
    return (
      !this.embedMode &&
      !this.openInDialog &&
      !this.previewLogicalId &&
      !!this.flowData?.rowKey &&
      !this.isFlowOwner()
    );
  }

  private questionAnswerKey(formKey: string): string {
    return `${this.flowData?.rowKey || ""}:${formKey}`;
  }

  private stepQuestionFormKey(index: number): string {
    const step = this.flowData?.steps?.[index];
    return step?.rowKey || step?.RowKey || `step-${index}`;
  }

  private pendingStepQuestionForm(index: number): GuideQuestionForm | null {
    if (!this.questionFormsEnabled || index < 0) return null;
    const step = this.flowData?.steps?.[index];
    if (!step) return null;
    const form = parseGuideQuestionForm(step.questionForm ?? step.QuestionForm);
    if (!isGuideQuestionFormActive(form)) return null;
    return this.answeredQuestionForms.has(this.questionAnswerKey(this.stepQuestionFormKey(index))) ? null : form;
  }

  private pendingEndQuestionForm(): GuideQuestionForm | null {
    if (!this.questionFormsEnabled) return null;
    const form = parseGuideQuestionForm(this.flowData?.endQuestionForm ?? this.flowData?.EndQuestionForm);
    if (!isGuideQuestionFormActive(form)) return null;
    return this.answeredQuestionForms.has(this.questionAnswerKey(GUIDE_END_FORM_KEY)) ? null : form;
  }

  /** Shown on the last step while its own questions or the end-of-guide questions are unanswered. */
  get showGuideFinishButton(): boolean {
    if (!this.isLastSlide || this.selectedStepIndex < 0) return false;
    return !!(this.pendingStepQuestionForm(this.selectedStepIndex) || this.pendingEndQuestionForm());
  }

  /**
   * Opens the current step's unanswered form, if any, and runs `onDone` once it is submitted or skipped.
   * Returns true when navigation must wait (a form is open or was just opened).
   */
  private gateOnStepQuestions(onDone: () => void): boolean {
    if (this.questionDialogOpen) return true;
    const index = this.selectedStepIndex;
    const form = this.pendingStepQuestionForm(index);
    if (!form) return false;
    this.openQuestionDialog(form, this.stepQuestionFormKey(index), index, onDone);
    return true;
  }

  /**
   * Jumping ahead from the step list asks the questions on the step being left, and on any
   * step already seen on the way to the target. Steps the viewer skipped are asked when visited.
   */
  private gateForwardNavigation(target: number, onDone: () => void): boolean {
    if (this.questionDialogOpen) return true;
    const current = this.selectedStepIndex;
    if (target <= current) return false;
    const stepCount = this.flowData?.steps?.length || 0;
    for (let i = Math.max(current, 0); i < Math.min(target, stepCount); i++) {
      if (i !== current && !this.isStepVisited(i)) continue;
      const form = this.pendingStepQuestionForm(i);
      if (form) {
        this.openQuestionDialog(form, this.stepQuestionFormKey(i), i, onDone);
        return true;
      }
    }
    return false;
  }

  get currentStepQuestionCount(): number {
    return this.pendingStepQuestionForm(this.selectedStepIndex)?.questions.length || 0;
  }

  openCurrentStepQuestions(): void {
    const index = this.selectedStepIndex;
    const form = this.pendingStepQuestionForm(index);
    if (!form || this.questionDialogOpen) return;
    this.openQuestionDialog(form, this.stepQuestionFormKey(index), index, () => undefined);
  }

  finishGuide(): void {
    if (this.gateOnStepQuestions(() => this.finishGuide())) return;
    const endForm = this.pendingEndQuestionForm();
    if (!endForm || this.questionDialogOpen) return;
    this.openQuestionDialog(endForm, GUIDE_END_FORM_KEY, null, () => {
      this.toastr.success("Thanks! Your answers were saved.");
    }, "Submit and finish");
  }

  private openQuestionDialog(
    form: GuideQuestionForm,
    formKey: string,
    stepIndex: number | null,
    onDone: () => void,
    submitLabel?: string
  ): void {
    this.stopAutoplay();
    this.questionDialogOpen = true;
    GuideQuestionFormDialogComponent.open(this.dialog, {
      form,
      flowId: this.flowData.rowKey,
      formKey,
      stepIndex,
      sessionId: this.questionSessionId,
      flowVersion: this.flowData?.version || this.flowData?.Version || null,
      submitLabel,
    }).subscribe((result) => {
      this.questionDialogOpen = false;
      if (result === "submitted" || result === "skipped") {
        this.answeredQuestionForms.add(this.questionAnswerKey(formKey));
        onDone();
      }
      this.cdr.markForCheck();
    });
  }

  /** Org Worker / end user in the active org: gets the minimal reader view. */
  isOrgEndUserView = false;
  /** Task mode is an organization feature; it is hidden in Public account mode. */
  showTaskModeButton = false;
  private orgContextSub?: Subscription;

  private static readonly ORG_END_USER_HIDDEN_FEATURES = new Set<string>([
    "showShare",
    "showLike",
    "showReview",
    "showQr",
    "showReport",
    "showFollow",
    "showSchedule",
    "showConsult",
    "showCopyLinks",
    "showTransfer",
    "allowEmbed",
  ]);

  /**
   * Per-flow viewer interaction toggles. Missing/null flags default to enabled
   * so legacy flows keep full UI. Governance flags (download/print/embed) default off.
   * Feedback channels honor optional date windows (NEW-01).
   * Org end users never get social / sharing actions, whatever the flow allows.
   */
  viewerFeature(
    key:
      | "showShare"
      | "showComments"
      | "showLike"
      | "showReview"
      | "showSave"
      | "showQr"
      | "showReport"
      | "showFollow"
      | "showSchedule"
      | "showConsult"
      | "showChatbot"
      | "showCopyLinks"
      | "showTransfer"
      | "showQuestions"
      | "showImprovementFeedback"
      | "allowDownload"
      | "allowPrint"
      | "allowEmbed"
  ): boolean {
    if (
      this.isOrgEndUserView &&
      ViewflowComponent.ORG_END_USER_HIDDEN_FEATURES.has(key)
    ) {
      return false;
    }
    const vf =
      this.flowData?.viewerFeatures ||
      this.flowData?.ViewerFeatures ||
      null;
    if (!vf) {
      if (key === "allowDownload" || key === "allowPrint" || key === "allowEmbed") {
        return false;
      }
      return true;
    }

    const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
    const raw = vf[key] !== undefined ? vf[key] : vf[pascalKey];
    const enabled = raw !== false;

    const feedbackKeys = ["showComments", "showReview", "showQuestions", "showImprovementFeedback", "showChatbot"];
    if (enabled && feedbackKeys.indexOf(key) >= 0) {
      const start = vf.feedbackWindowStartUtc || vf.FeedbackWindowStartUtc;
      const end = vf.feedbackWindowEndUtc || vf.FeedbackWindowEndUtc;
      const now = Date.now();
      if (start && now < new Date(start).getTime()) return false;
      if (end && now > new Date(end).getTime()) return false;
    }

    return enabled;
  }

  get showEmbedNavigation(): boolean {
    return !this.embedMode || this.embedViewType === "full";
  }

  get isEmbedNavigationLocked(): boolean {
    return this.embedMode && this.embedViewType !== "full";
  }

  /**
   * Canonical, non-embed guide link used by the embed player's "Copy Link"
   * action. Falls back to the current URL (with the /embed prefix stripped).
   */
  get embedShareLink(): string {
    if (typeof window === "undefined") {
      return "";
    }
    const origin = window.location?.origin ?? "";
    const title =
      this.activateRouter.snapshot.paramMap.get("title") ??
      this.flowData?.title ??
      "";
    const rowKey =
      this.activateRouter.snapshot.paramMap.get("rowKey") ??
      this.flowData?.rowKey ??
      "";
    if (title && rowKey) {
      return `${origin}/guide/${title}/${rowKey}`;
    }
    return (window.location?.href ?? "").replace("/embed/guide/", "/guide/");
  }

  constructor(
    private activateRouter: ActivatedRoute,
    private dataService: DataService,
    private userserviceService: UserserviceService,
    private flowServiceService: FlowServiceService,
    private bundleService: BundleService,
    private toastr: ToastrService,
    public formbuilder: UntypedFormBuilder,
    public router: Router,
    public dialog: MatDialog,
    private titleandmetaserviceService: TitleandmetaserviceService,
    private pageTimeTrackerService: PageTimeTrackerService,
    private flowservice: FlowServiceService,
    private authModalService : AuthModalService,
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService,
    private versioningService: VersioningService,
    private flowNavigationService: FlowNavigationService,
    private orgContextService: OrgContextService,
    @Optional() private dialogRef?: MatDialogRef<ViewflowComponent>
  ) {
    this.isFlowHomePage = true;
    this.categories = [];
    this.duration = null;
    this.flowData = null;
    this.stepText =
      "Check that you have all items required to complete the instruction";
    // this.noResultReturned = false;

    // Track MatDialog open/close state to hide chatbot when any modal is open
    this.dialog.afterOpened.subscribe(() => {
      this.isAnyDialogOpen = true;
      this.cdr.markForCheck();
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.isAnyDialogOpen = false;
      this.cdr.markForCheck();
    });

    this.orgContextSub = this.orgContextService.watch().subscribe(() => {
      this.isOrgEndUserView = this.orgContextService.isOrgEndUser();
      this.showTaskModeButton = this.orgContextService.isOrganizationMode();
      this.openTaskModeByDefault();
      this.cdr.markForCheck();
    });
  }

  private taskModeDefaultApplied = false;

  /**
   * Org end users land in task mode once the guide has passed access checks.
   * `?full=1` (the task mode "Full view" button) keeps the full guide page.
   */
  private openTaskModeByDefault(): void {
    if (this.taskModeDefaultApplied || !this.isOrgEndUserView) return;
    if (this.openInDialog || this.embedMode || this.previewLogicalId) return;
    const loadedRowKey = this.flowData?.rowKey || this.flowData?.RowKey;
    if (!loadedRowKey) return;
    if (this.activateRouter.snapshot.paramMap.get("rowKey") !== loadedRowKey) return;
    if (this.activateRouter.snapshot.queryParamMap.get("full") === "1") return;
    this.taskModeDefaultApplied = true;
    this.openTaskMode(true);
  }

  closePreviewDialog(): void {
    if (this.openInDialog) {
      this.dialogRef?.close();
      return;
    }
    this.dialog.closeAll();
  }

  openScheduleView(): void {
    if (!this.userData) {
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal("registration", this.router.url);
      return;
    }
    if (!this.flowData) {
      return;
    }

    this.dialog.open(ScheduleViewDialogComponent, {
      width: "520px",
      maxWidth: "95vw",
      panelClass: "dialoguebox",
      data: {
        entityType: "flow",
        title: this.flowData?.title || "Flow",
        linkUrl: window?.location?.href,
      },
    });
  }

  /**
   * Human-readable unique code for the live view page and version preview.
   * Prefers uniqueCode; falls back to uniqueId / uniqueCodeWithoutDot (same as RowKey for new flows).
   */
  get uniqueCodeDisplay(): string {
    if (!this.flowData) {
      return "";
    }
    const f = this.flowData;
    const code = `${f.uniqueCode || f.UniqueCode || ""}`.trim();
    if (code) {
      return code;
    }
    const uid = `${
      f.uniqueId || f.UniqueId || f.flowUniqueId || f.FlowUniqueId || ""
    }`.trim();
    if (uid) {
      return uid.replace(/\./g, "");
    }
    return `${f.uniqueCodeWithoutDot || f.UniqueCodeWithoutDot || ""}`.trim();
  }

  /** True for tick or undotted UniqueId RowKeys. */
  private hasFlowRowKey(rowKey: any): boolean {
    if (rowKey === null || rowKey === undefined) {
      return false;
    }
    const value = `${rowKey}`.trim();
    return value !== "" && value !== "0";
  }

  /** Version preview dialog header — same field resolution as the live page. */
  get previewUniqueCodeDisplay(): string {
    if (!this.openInDialog) {
      return "";
    }
    return this.uniqueCodeDisplay;
  }

  /** Used only in version preview dialog when API cannot load snapshot. */
  previewUnavailableMessage: string | null = null;

  /** Owner, co-authors and members of the owning organization can see the activity log. */
  get canViewActivity(): boolean {
    const email = String(this.userData?.emailAddress || "").toLowerCase();
    if (!email || !this.flowData?.rowKey || this.openInDialog || this.embedMode) return false;
    if (String(this.flowData.customerEmail || "").toLowerCase() === email) return true;
    const coAuthors = String(
      this.flowData.coAuthorEmails || this.flowData.CoAuthorEmails || ""
    ).toLowerCase();
    if (coAuthors.includes(email)) return true;
    const orgId = this.flowData.organizationId || this.flowData.OrganizationId;
    return this.orgContextService.isActiveMemberOf(orgId);
  }

  openActivityDialog(): void {
    if (!this.flowData?.rowKey) return;
    ContentActivityPanelComponent.open(this.dialog, {
      contentType: "guide",
      contentId: this.flowData.rowKey,
      title: this.flowData.title,
    });
  }

  openVersionHistoryDialog(): void {
    const logicalId = this.flowData?.rowKey;
    if (!logicalId) {
      return;
    }
    const isOwner =
      !!this.userData?.emailAddress &&
      !!this.flowData?.customerEmail &&
      this.userData.emailAddress === this.flowData.customerEmail;

    const dialogRef = this.dialog.open(VersionHistoryPanelComponent, {
      width: "640px",
      data: {
        entityType: "flow",
        logicalId,
        canManageVersions: isOwner,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      const id =
        result?.logicalId || this.flowData?.rowKey;
      if (
        !result ||
        !id ||
        (result.action !== "restore" && result.action !== "delete")
      ) {
        return;
      }
      this.getFlowDetails(id);
    });
  }

  private loadFlowVersion(logicalId: string, version: number): void {
    this.isInitialLoading = true;
    this.previewUnavailableMessage = null;

    let email = "";
    try {
      const u = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
      email = u?.emailAddress || "";
    } catch {
      email = "";
    }

    forkJoin({
      versionModel: this.versioningService.getFlowByVersion(logicalId, version),
      livePayload: this.flowServiceService
        .getFlowById(
          new FlowQueryModel({
            FlowId: logicalId,
            userEmail: email,
          })
        )
        .pipe(catchError(() => of(null))),
    }).subscribe({
      next: ({ versionModel, livePayload }) => {
        if (!versionModel) {
          this.flowData = null;
          this.steps = [];
          this.dataSource = [];
          this.dataSourceSteps = [];
          this.stepCount = 0;
          this.IsSteps = false;
          this.previewUnavailableMessage =
            "Preview of this version is not available.";
          this.isInitialLoading = false;
          this.cdr.markForCheck();
          return;
        }

        const live = livePayload?.flows ?? livePayload?.Flows ?? null;
        const mappedPreviewModel = this.mapFlowPreviewModel(
          versionModel,
          version
        );
        const model = this.mergeLiveFlowIdentityIntoVersionPreview(
          mappedPreviewModel,
          live
        );
        const normalizedModel = this.normalizeFlowModelForRendering(model);
        this.flowData = normalizedModel;
        this.steps = normalizedModel.steps || [];
        this.stepCount = this.steps.length || 0;
        this.dataSourceSteps = [];

        if (normalizedModel.components && normalizedModel.components.length > 0) {
          this.dataSource = normalizedModel.components;
          this.groupDataByGroupName();
        }

        if (this.steps.length) {
          this.IsSteps = true;
          this.loadSteps(this.steps);
        } else {
          this.IsSteps = false;
        }
        // Force preview to open on cover media
        this.selectedStepIndex = -2;
        this.itemsRequired = 0;
        this.coverPage = true;
        this.isFlowHomePage = true;
        this.moveOnCoverPage();
        this.isInitialLoading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.toastr.error("Preview of this version is not available.");
        this.flowData = null;
        this.steps = [];
        this.dataSource = [];
        this.dataSourceSteps = [];
        this.stepCount = 0;
        this.IsSteps = false;
        this.previewUnavailableMessage =
          "Preview of this version is not available.";
        this.flowNotFound = true;
        this.isInitialLoading = false;
        this.cdr.markForCheck();
      },
    });
  }

  private mapFlowPreviewModel(rawModel: any, versionNumber: number): any {
    const tryParseJson = (value: any): any => {
      if (!value || typeof value !== "string") return null;
      try {
        return JSON.parse(value);
      } catch {
        return null;
      }
    };

    const pickFirst = (obj: any, keys: string[]): any => {
      for (const key of keys) {
        const val = obj?.[key];
        if (val !== null && val !== undefined && `${val}`.trim() !== "") {
          return val;
        }
      }
      return "";
    };

    const deepFindByKeys = (obj: any, keys: string[]): any => {
      if (!obj || typeof obj !== "object") return "";
      const targets = new Set(keys.map((k) => k.toLowerCase()));
      const queue: any[] = [obj];
      const seen = new Set<any>();

      while (queue.length) {
        const current = queue.shift();
        if (!current || typeof current !== "object" || seen.has(current)) continue;
        seen.add(current);
        for (const key of Object.keys(current)) {
          const val = (current as any)[key];
          if (
            targets.has(key.toLowerCase()) &&
            val !== null &&
            val !== undefined &&
            `${val}`.trim() !== ""
          ) {
            return val;
          }
          if (val && typeof val === "object") {
            queue.push(val);
          }
        }
      }
      return "";
    };

    const base =
      rawModel?.updatedFlow ||
      rawModel?.flowModel ||
      rawModel?.FlowModel ||
      rawModel;

    const parsedFromString =
      tryParseJson(rawModel?.updatedFlowJson) ||
      tryParseJson(rawModel?.UpdatedFlowJson) ||
      tryParseJson(rawModel?.flowJson) ||
      tryParseJson(rawModel?.FlowJson) ||
      tryParseJson(base);

    const source = parsedFromString || base || {};
    const stepsRaw = source?.steps || source?.Steps || [];
    const componentsRaw = source?.components || source?.Components || [];

    // For cover preview, do NOT deep-scan full source (can incorrectly pick step media).
    // Only read top-level + explicit cover objects.
    const coverSource =
      source?.coverPage ||
      source?.CoverPage ||
      source?.cover ||
      source?.Cover ||
      source?.flowCoverPageDetails ||
      source?.FlowCoverPageDetails ||
      null;

    const apiUrlAsIs =
      source?.url ??
      source?.Url ??
      base?.url ??
      base?.Url ??
      rawModel?.url ??
      rawModel?.Url;

    const mappedUrl =
      pickFirst(source, [
        "url",
        "Url",
        "mediaUrl",
        "MediaUrl",
        "filePath",
        "FilePath",
        "imageUrl",
        "ImageUrl",
        "coverImage",
        "CoverImage",
      ]) ||
      pickFirst(base, [
        "url",
        "Url",
        "mediaUrl",
        "MediaUrl",
        "filePath",
        "FilePath",
        "imageUrl",
        "ImageUrl",
        "coverImage",
        "CoverImage",
      ]) ||
      pickFirst(rawModel, [
        "url",
        "Url",
        "mediaUrl",
        "MediaUrl",
        "filePath",
        "FilePath",
        "imageUrl",
        "ImageUrl",
        "coverImage",
        "CoverImage",
      ]) ||
      pickFirst(coverSource, [
        "url",
        "Url",
        "mediaUrl",
        "MediaUrl",
        "filePath",
        "FilePath",
        "imageUrl",
        "ImageUrl",
        "coverImage",
        "CoverImage",
      ]) ||
      deepFindByKeys(coverSource, [
        "url",
        "mediaUrl",
        "filePath",
        "imageUrl",
        "coverImage",
      ]);

    const mappedPoster =
      pickFirst(source, [
        "videoThumbNailUrl",
        "VideoThumbNailUrl",
        "videoThumbnailUrl",
        "VideoThumbnailUrl",
        "coverPosterPageURI",
        "CoverPosterPageURI",
        "posterUrl",
        "PosterUrl",
      ]) ||
      pickFirst(coverSource, [
        "videoThumbNailUrl",
        "VideoThumbNailUrl",
        "videoThumbnailUrl",
        "VideoThumbnailUrl",
        "coverPosterPageURI",
        "CoverPosterPageURI",
        "posterUrl",
        "PosterUrl",
      ]) ||
      deepFindByKeys(coverSource, [
        "videoThumbNailUrl",
        "videoThumbnailUrl",
        "coverPosterPageURI",
        "posterUrl",
      ]);

    const resolvedUrl = this.normalizeMediaUrl(apiUrlAsIs || mappedUrl || "");
    const resolvedPoster = this.normalizeMediaUrl(mappedPoster || "");

    return {
      ...source,
      rowKey: source?.rowKey || source?.RowKey || this.previewLogicalId || "",
      title: source?.title || source?.Title || "",
      description: source?.description || source?.Description || "",
      // Keep `url` property name as-is for preview model rendering path.
      url: resolvedUrl,
      Url: resolvedUrl,
      videoThumbNailUrl: resolvedPoster,
      VideoThumbNailUrl: resolvedPoster,
      steps: Array.isArray(stepsRaw) ? stepsRaw : [],
      components: Array.isArray(componentsRaw) ? componentsRaw : [],
      version: source?.version ?? source?.Version ?? versionNumber,
      type: source?.type || source?.Type || "Flow",
    };
  }

  private normalizeMediaUrl(value: any): string {
    if (value == null) {
      return "";
    }
    let out = `${value}`.trim();
    if (!out) {
      return "";
    }

    // Remove wrapping quotes from serialized JSON values
    if (
      (out.startsWith('"') && out.endsWith('"')) ||
      (out.startsWith("'") && out.endsWith("'"))
    ) {
      out = out.substring(1, out.length - 1).trim();
    }

    // Unescape common URL escapes from version snapshots
    out = out
      .replace(/\\u002F/gi, "/")
      .replace(/\\\//g, "/")
      .replace(/\\\\/g, "\\");

    // Normalize malformed escaped protocols
    out = out.replace(/^https?:\\+/i, (m) => m.replace(/\\/g, "/"));
    out = out.replace(/^https?:\/(?!\/)/i, (m) => `${m}/`);

    return out;
  }

  /** API version snapshot omits unique ids; fill from live flow for preview header (like bundle preview). */
  private mergeLiveFlowIdentityIntoVersionPreview(
    versionModel: any,
    live: any | null
  ): any {
    if (!live) {
      return versionModel;
    }
    const out = { ...versionModel };
    const has = (v: string) => v != null && `${v}`.trim() !== "";

    // Hydrate cover media from live flow when version snapshot is missing it.
    const currentUrl = this.normalizeMediaUrl(out.url || out.Url || "");
    const currentPoster = this.normalizeMediaUrl(
      out.videoThumbNailUrl || out.VideoThumbNailUrl || ""
    );
    if (!has(currentUrl)) {
      const liveUrl = this.normalizeMediaUrl(live.url || live.Url || "");
      if (has(liveUrl)) {
        out.url = liveUrl;
        out.Url = liveUrl;
      }
    } else {
      out.url = currentUrl;
      out.Url = currentUrl;
    }
    if (!has(currentPoster)) {
      const livePoster = this.normalizeMediaUrl(
        live.videoThumbNailUrl || live.VideoThumbNailUrl || ""
      );
      if (has(livePoster)) {
        out.videoThumbNailUrl = livePoster;
        out.VideoThumbNailUrl = livePoster;
      }
    } else {
      out.videoThumbNailUrl = currentPoster;
      out.VideoThumbNailUrl = currentPoster;
    }

    if (!has(out.uniqueCode) && !has(out.UniqueCode)) {
      const c = live.uniqueCode || live.UniqueCode;
      if (has(c)) {
        out.uniqueCode = c;
      }
    }
    if (!has(out.uniqueId) && !has(out.UniqueId)) {
      const id = live.uniqueId || live.UniqueId || live.flowUniqueId || live.FlowUniqueId;
      if (has(id)) {
        out.uniqueId = id;
      }
    }
    if (!has(out.uniqueCodeWithoutDot) && !has(out.UniqueCodeWithoutDot)) {
      const nd =
        live.uniqueCodeWithoutDot ||
        live.UniqueCodeWithoutDot ||
        "";
      if (has(nd)) {
        out.uniqueCodeWithoutDot = nd;
      }
    }

    // Always hydrate collaboration identity and sponsored flag from live flow (not stored in version snapshot)
    const liveIsSponsored = live.isSponsored ?? live.IsSponsored;
    if (liveIsSponsored != null) {
      out.isSponsored = liveIsSponsored;
    }
    const liveIsCollab = live.isCollaboration ?? live.IsCollaboration;
    if (liveIsCollab != null) {
      out.isCollaboration = liveIsCollab;
    }
    const liveCoEmail = live.coAuthorEmail || live.CoAuthorEmail;
    if (has(liveCoEmail)) {
      out.coAuthorEmail = liveCoEmail;
      out.CoAuthorEmail = liveCoEmail;
    }
    const liveCoEmails = live.coAuthorEmails || live.CoAuthorEmails;
    if (has(liveCoEmails)) {
      out.coAuthorEmails = liveCoEmails;
    }
    const liveCoUserNames = live.coAuthorUserNames || live.CoAuthorUserNames;
    if (has(liveCoUserNames)) {
      out.coAuthorUserNames = liveCoUserNames;
    }
    const liveCoProfilePicUrls = live.coAuthorProfilePicUrls || live.CoAuthorProfilePicUrls;
    if (has(liveCoProfilePicUrls)) {
      out.coAuthorProfilePicUrls = liveCoProfilePicUrls;
    }
    const liveCoName = live.coAuthorUserName || live.CoAuthorUserName;
    if (has(liveCoName)) {
      out.coAuthorUserName = liveCoName;
      out.CoAuthorUserName = liveCoName;
    }
    const liveCoAvatar = live.coAuthorProfilePicUrl || live.CoAuthorProfilePicUrl;
    if (has(liveCoAvatar)) {
      out.coAuthorProfilePicUrl = liveCoAvatar;
    }

    return out;
  }

  /**
   * Normalize flow payload keys for rendering.
   * Handles APIs that return PascalCase keys in preview mode.
   */
  private normalizeFlowModelForRendering(flowModel: any): any {
    if (!flowModel) {
      return flowModel;
    }

    const normalized: any = { ...flowModel };
    normalized.url = this.normalizeMediaUrl(
      flowModel.url ||
      flowModel.Url ||
      flowModel.coverImage ||
      flowModel.CoverImage ||
      flowModel.mediaUrl ||
      flowModel.MediaUrl ||
      ""
    );
    normalized.videoThumbNailUrl = this.normalizeMediaUrl(
      flowModel.videoThumbNailUrl ||
      flowModel.VideoThumbNailUrl ||
      flowModel.coverPosterPageURI ||
      flowModel.CoverPosterPageURI ||
      flowModel.posterUrl ||
      flowModel.PosterUrl ||
      ""
    );
    normalized.description = flowModel.description || flowModel.Description || "";
    normalized.components = flowModel.components || flowModel.Components || [];
    normalized.duration = flowModel.duration ?? flowModel.Duration ?? null;
    normalized.durationUnit = flowModel.durationUnit || flowModel.DurationUnit || 'Mins';
    normalized.type = flowModel.type || flowModel.Type || "Flow";
    normalized.Type = normalized.type;
    normalized.isSponsored = flowModel.isSponsored ?? flowModel.IsSponsored ?? false;
    normalized.commentCount =
      flowModel.commentCount ?? flowModel.CommentCount ?? 0;
    normalized.rowKey = flowModel.rowKey || flowModel.RowKey || normalized.rowKey;

    // Normalize collaboration fields (API returns PascalCase)
    normalized.isCollaboration = flowModel.isCollaboration ?? flowModel.IsCollaboration ?? false;
    normalized.coAuthorEmail = flowModel.coAuthorEmail || flowModel.CoAuthorEmail || null;
    normalized.coAuthorEmails = flowModel.coAuthorEmails || flowModel.CoAuthorEmails || null;
    normalized.coAuthorUserNames = flowModel.coAuthorUserNames || flowModel.CoAuthorUserNames || null;
    normalized.coAuthorProfilePicUrls = flowModel.coAuthorProfilePicUrls || flowModel.CoAuthorProfilePicUrls || null;
    normalized.coAuthorUserName = flowModel.coAuthorUserName || flowModel.CoAuthorUserName || null;
    normalized.coAuthorProfilePicUrl = flowModel.coAuthorProfilePicUrl || flowModel.CoAuthorProfilePicUrl || null;

    const rawSteps = flowModel.steps || flowModel.Steps || [];
    normalized.steps = Array.isArray(rawSteps)
      ? rawSteps.map((step: any) => ({
          ...step,
          url: this.normalizeMediaUrl(
            step?.url ||
            step?.Url ||
            step?.coverImage ||
            step?.CoverImage ||
            step?.mediaUrl ||
            step?.MediaUrl ||
            ""
          ),
          videoThumbNailUrl: this.normalizeMediaUrl(
            step?.videoThumbNailUrl ||
            step?.VideoThumbNailUrl ||
            step?.coverPosterPageURI ||
            step?.CoverPosterPageURI ||
            step?.posterUrl ||
            step?.PosterUrl ||
            ""
          ),
          description: step?.description || step?.Description || "",
          title: step?.title || step?.Title || "",
        }))
      : [];

    return normalized;
  }

  /** Subject category label for cover view (excludes Flow/Bundle content types). */
  getFlowCategoryLabel(): string | null {
    const raw = String(this.flowData?.type || this.flowData?.Type || "").trim();
    if (!raw || raw === "Flow" || raw === "Bundle") {
      return null;
    }
    return raw;
  }

  /** Map API comment payload (camelCase or PascalCase) to template field names. */
  private normalizeCommentForUi(raw: any): any {
    if (!raw) {
      return raw;
    }
    const childRaw = raw.childComments ?? raw.ChildComments ?? [];
    return {
      ...raw,
      rowKey: raw.rowKey ?? raw.RowKey,
      comment: raw.comment ?? raw.Comment ?? "",
      customerUserName: raw.customerUserName ?? raw.CustomerUserName ?? "",
      commentedByUserEmail:
        raw.commentedByUserEmail ?? raw.CommentedByUserEmail ?? "",
      createdDate: raw.createdDate ?? raw.CreatedDate ?? "",
      profilePic: raw.profilePic ?? raw.ProfilePic ?? "",
      parentCommentId: raw.parentCommentId ?? raw.ParentCommentId ?? null,
      isCommentLiked: raw.isCommentLiked ?? raw.IsCommentLiked,
      totalLikedComments:
        raw.totalLikedComments ?? raw.TotalLikedComments ?? 0,
      isFlowOwner: !!(raw.isFlowOwner ?? raw.IsFlowOwner),
      childComments: Array.isArray(childRaw)
        ? childRaw.map((c: any) => this.normalizeCommentForUi(c))
        : [],
    };
  }

  private loadLatestVersion(): void {
    const logicalId = this.flowData?.rowKey;
    if (!logicalId) return;

    this.versioningService.getFlowVersionHistory(logicalId).subscribe({
      next: (versions) => {
        if (versions && versions.length > 0) {
          // Find the current version or use the highest version number
          const currentVersion = versions.find(v => v.isCurrent);
          if (currentVersion) {
            this.flowData.version = currentVersion.version;
          } else {
            // Fallback to highest version number
            const latestVersion = Math.max(...versions.map(v => v.version));
            this.flowData.version = latestVersion;
          }
          this.cdr.markForCheck();
        }
      },
      error: (err) => {
        console.error('Failed to load version history:', err);
      }
    });
  }

  scrollToStep() {
    if (this.isMobileView && this.isToggled) {
      this.scrollToMobileSection();
      return;
    }

    setTimeout(() => {
      // Scroll sidebar (vertical scroll)
      if (
        this.stepButtons?.nativeElement &&
        this.stepScrollContainer?.nativeElement
      ) {
        const scrollContainer = this.stepScrollContainer.nativeElement;
        const buttonsContainer = this.stepButtons.nativeElement;
        const buttons = buttonsContainer.children;

        // Calculate which button index to scroll to
        // -2 = Cover (index 0), -1 = Items (index 1), 0+ = Steps (index 2+)
        const buttonIndex = this.selectedStepIndex + 2;
        const selectedButton = buttons[buttonIndex];

        if (selectedButton) {
          // Get the position of the button relative to the buttons container
          const buttonTop = selectedButton.offsetTop;
          const buttonHeight = selectedButton.offsetHeight;

          // Get the scroll container's current scroll position and dimensions
          const containerScrollTop = scrollContainer.scrollTop;
          const containerHeight = scrollContainer.clientHeight;

          // Calculate the button's position relative to the scroll container
          const buttonRelativeTop = buttonTop;
          const buttonRelativeBottom = buttonRelativeTop + buttonHeight;

          // Check if button is not fully visible
          const isAboveViewport = buttonRelativeTop < containerScrollTop;
          const isBelowViewport =
            buttonRelativeBottom > containerScrollTop + containerHeight;

          if (isAboveViewport || isBelowViewport) {
            // Scroll to center the button in the viewport
            const scrollToPosition =
              buttonRelativeTop - containerHeight / 2 + buttonHeight / 2;

            scrollContainer.scrollTo({
              top: Math.max(0, scrollToPosition),
              behavior: "smooth",
            });
          }
        }
      }

      // Scroll top panel (horizontal scroll)
      if (this.flowInfoPanel?.nativeElement) {
        const topPanel = this.flowInfoPanel.nativeElement;
        // Find the active badge using the .active class
        const selectedBadge = topPanel.querySelector(
          ".info-badge.active"
        ) as HTMLElement;

        if (selectedBadge) {
          // Get the position of the badge relative to the panel
          const badgeLeft = selectedBadge.offsetLeft;
          const badgeWidth = selectedBadge.offsetWidth;

          // Get the panel's current scroll position and dimensions
          const panelScrollLeft = topPanel.scrollLeft;
          const panelWidth = topPanel.clientWidth;

          // Calculate the badge's position relative to the scroll container
          const badgeRelativeLeft = badgeLeft;
          const badgeRelativeRight = badgeRelativeLeft + badgeWidth;

          // Check if badge is not fully visible
          const isLeftOfViewport = badgeRelativeLeft < panelScrollLeft;
          const isRightOfViewport =
            badgeRelativeRight > panelScrollLeft + panelWidth;

          if (isLeftOfViewport || isRightOfViewport) {
            // Scroll to center the badge in the viewport
            const scrollToPosition =
              badgeRelativeLeft - panelWidth / 2 + badgeWidth / 2;

            topPanel.scrollTo({
              left: Math.max(0, scrollToPosition),
              behavior: "smooth",
            });
          }
        }
      }
    }, 100);
  }

  private scrollToMobileSection() {
    setTimeout(() => {
      let target: HTMLElement | null = null;

      if (this.selectedStepIndex === -2) {
        target = this.mobileCoverSection?.nativeElement ?? null;
      } else if (this.selectedStepIndex === -1) {
        target = this.mobileItemsSection?.nativeElement ?? null;
      } else if (
        this.mobileStepSections &&
        this.mobileStepSections.length > this.selectedStepIndex &&
        this.selectedStepIndex >= 0
      ) {
        target =
          this.mobileStepSections.toArray()[this.selectedStepIndex]
            ?.nativeElement ?? null;
      }

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  }

  isVideoUrl(url: string): boolean {
    if (!url) {
      return false;
    }
    const extension = this.getExtension(url);
    if (!extension) {
      return false;
    }
    return this.videoFileExtensions.includes(extension.toLowerCase());
  }

  // This method will be triggered on every keyup event
  onQuestionChange() {
    if (this.question) {
      this.getSupportFaqsByQuestion(this.question);
    }
  }

  // Handles group selection and appends group info to conversationHistory
  onGroupSelect(group: any) {
    this.checkFlowPaid();
    // Append the selected group to conversation history
    this.conversationHistory.push({
      question: `Selected Group: ${group.groupName}`,
      answer: "", // Empty answer for group selection
      isGroupSelection: true,
    });
    console.log("inside grp select");
    // Set the selected group
    if (this.selectedGroup === group) {
      this.selectedGroup = group;
      console.log(this.conversationHistory);
      this.faqSelection = true;

      // this.faqSelection = this.conversationHistory.length > 1 ? false : true;
      console.log(this.faqSelection);
    } else {
      this.selectedGroup = group;
      this.faqSelection = true;
    }
  }

  // Toggle function to show or hide the div
  toggleDiv() {
    const openingChat = !this.isDivVisible;
    this.isDivVisible = !this.isDivVisible;
    if (openingChat) {
      this.pauseVideoForChatOpen();
    } else {
      this.resumeVideoIfInterruptedByChat();
    }
  }

  // Close function to hide the div
  closeDiv() {
    this.isDivVisible = false;
    this.resumeVideoIfInterruptedByChat();
  }

  private pauseVideoForChatOpen(): void {
    const video = this.getMainVideoElement();
    if (!video) {
      this.chatInterruptedVideo = false;
      return;
    }

    this.chatInterruptedVideo = !video.paused && !video.ended;
    if (this.chatInterruptedVideo) {
      video.pause();
    }
  }

  private resumeVideoIfInterruptedByChat(): void {
    if (!this.chatInterruptedVideo) {
      return;
    }

    const video = this.getMainVideoElement();
    if (!video) {
      this.chatInterruptedVideo = false;
      return;
    }

    video.play().catch(() => {
      // Ignore autoplay block errors; user can manually resume playback.
    });
    this.chatInterruptedVideo = false;
  }

  private getMainVideoElement(): HTMLVideoElement | null {
    if (this.videoPlayer?.nativeElement) {
      return this.videoPlayer.nativeElement;
    }

    return document.querySelector("video.main-video-player");
  }
  // Handles FAQ selection and appends question to conversationHistory
  onFaqSelect(faq: any) {
    this.selectedFaq = faq;

    // Append the selected FAQ to conversation history
    this.conversationHistory.push({
      question: faq.question,
      answer: faq.answer,
      isGroupSelection: false,
    });
    // Call API to fetch the answer
    this.getSupportFaqsByQuestion(faq.question);
  }

  // Method triggered when user submits a question
  onQuestionSubmit() {
    this.checkFlowPaid();
    if (this.question.trim() !== "") {
      // Add user question to conversation history
      this.conversationHistory.push({
        question: this.question,
        answer: "Loading...",
        isGroupSelection: false,
      });

      // Simulate fetching answer from backend
      this.getSupportFaqsByQuestion(this.question);
      // Clear the input field
      this.question = "";
      this.selectedGroup = null;

      console.log("inside questionsumit");
    }
  }

  openLink(iname) {
    var url = iname.wheretofindit;
    if (this.isPurchaseRequired) return;
    else {
      if (url.includes("https://")) {
        url = url;
        window.open(url);
        this.recordLinkClick(iname);
      } else {
        url = "https://" + url;
        window.open(url);
        this.recordLinkClick(iname);
      }
    }
  }

  ViewSupportingDocuments() {
    if (this.flowData.isPaid && this.userData == null) {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
  this.authModalService.openModal('registration', this.router.url);
    } else {
      //this.router.navigate(["/in-Appropriate"]);
      localStorage.setItem("flowData", JSON.stringify(this.flowData));
      const dialogRef = this.dialog.open(SupportDocumentComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {});
    }
  }
  openSupportingDocument(doc: any) {
    if (this.flowData.isPaid && !this.flowData.isFlowPurchased) {
      if (this.userData == null) {
        this.authModalService.openModal('registration', this.router.url);
        return;
      }
      if (this.userData.emailAddress !== this.flowData.customerEmail) {
        localStorage.setItem('checkoutFlow', JSON.stringify(this.flowData));
        this.router.navigate(['/checkout']);
        return;
      }
    }
    if (this.userData) {
      this.recordSupportingLinkClick(doc, true);
    }
    window.open(doc.documentUrl);
  }

  openSupportingLink(link: any) {
    if (this.flowData.isPaid && !this.flowData.isFlowPurchased) {
      if (this.userData == null) {
        this.authModalService.openModal('registration', this.router.url);
        return;
      }
      if (this.userData.emailAddress !== this.flowData.customerEmail) {
        localStorage.setItem('checkoutFlow', JSON.stringify(this.flowData));
        this.router.navigate(['/checkout']);
        return;
      }
    }
    let url = link.linkUrl || '';
    if (!url.includes('https://') && !url.includes('http://')) {
      url = 'https://' + url;
    }
    if (this.userData) {
      this.recordSupportingLinkClick(link, false);
    }
    window.open(url);
  }

  recordSupportingLinkClick(item: any, isDoc: boolean) {
    const linkClickDetails = {
      PartitionKey: this.flowData.rowKey,
      Link: isDoc ? item.documentUrl : item.linkUrl,
      LinkTitle: isDoc ? item.documentName : item.linkName,
      ContentTitle: this.flowData.title,
      UserEmail: this.userData?.emailAddress,
      ContentType: this.flowData.type === 'Bundle' ? 'Bundle' : this.flowData.type,
      ContentUrl: this.flowData.url,
    };
    this.flowservice.postLinkClick(linkClickDetails).subscribe(() => {});
  }

  ViewSupportingFaqs() {
    if (this.supportFlowFaqs && this.userData == null && this.flowData.isPaid) {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
  this.authModalService.openModal('registration', this.router.url);
    } else {
      //this.router.navigate(["/in-Appropriate"]);
      localStorage.setItem("flowData", JSON.stringify(this.flowData));
      localStorage.setItem("supportFaq", JSON.stringify(this.supportFlowFaqs));
      const dialogRef = this.dialog.open(SupportFaqComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {});
    }
  }

  checkFlowPaid() {
    console.log(this.userData);
    if (this.userData == null) {
      localStorage.setItem("flowData", JSON.stringify(this.flowData));
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
  this.authModalService.openModal('registration', this.router.url);
    } else if (
      this.userData.emailAddress !== this.flowData.customerEmail &&
      this.flowData.isPaid &&
      this.flowData.isFlowPurchased == false
    ) {
      this.isFlowPaid = false;
      localStorage.setItem("checkoutFlow", JSON.stringify(this.flowData));
      this.router.navigate(["/checkout"]);
    } else if (this.userData.emailAddress === this.flowData.customerEmail) {
      this.isFlowPaid = true;
    } else {
      this.isFlowPaid = true;
    }
    console.log(this.isFlowPaid);
  }
  getSupportFaqs(flowId) {
    console.log(flowId);
    var flowQueryModel = new FlowQueryModel({
      FlowId: flowId,
    });
    this.faqData = this.flowServiceService
      .getSupportFaq(flowQueryModel)
      .subscribe((data) => {
          this.loadFlowReviews(flowId);
        console.log(data);
        if (data != null && data.length > 0) {
          this.showFaq = true;
          this.supportFlowFaqs = data;
          this.groupFaqsByGroupName();
        } else {
          this.showFaq = false;
          // this.toastr.success(
          //   "The flow you are trying to open is no longer available. Explore how-to DIY flows here"
          // );
          //this.router.navigate(["/"]);
        }
        console.log(this.showFaq);
      });
  }

  getSupportFaqsByQuestion(question: string) {
    console.log(question);
    var flowQueryModel = new FlowQueryModel({
      category: question,
    });
    this.faqData = this.flowServiceService
      .getFaqDetailsByQuestion(flowQueryModel)
      .subscribe((data) => {
        this.noResultReturned = false;
        if (data != null && data.answer) {
          this.supportFlowFaqs = data;
          this.conversationHistory[this.conversationHistory.length - 1].answer =
            this.supportFlowFaqs.answer;
        } else {
          this.conversationHistory[this.conversationHistory.length - 1].answer =
            "Apologies, I may not have understood your question correctly. Could you please clarify? If I still don't get it, feel free to leave your question in the comment section!";
        }
        this.faqSelection = this.conversationHistory.length > 1 ? false : true;
      });
  }

  groupFaqsByGroupName() {
    const groups = this.supportFlowFaqs.reduce((acc: any, faq: any) => {
      const groupName = faq.groupName;
      if (!acc[groupName]) {
        acc[groupName] = [];
      }
      acc[groupName].push(faq);
      return acc;
    }, {});

    this.groupedFaqs = Object.keys(groups).map((groupName) => ({
      groupName: groupName,
      faqs: groups[groupName],
    }));
  }
  recordLinkClick(iname) {
    console.log(this.flowData);
    var linkClickDetails = {
      PartitionKey: this.flowData.rowKey,
      Link: iname.wheretofindit,
      LinkTitle: iname.itemkey,
      ContentTitle: this.flowData.title,
      UserEmail: this.userData.emailAddress,
      ContentType: this.flowData.type,
      ContentUrl: this.flowData.url,
    };

    linkClickDetails.Link = iname.wheretofindit;
    linkClickDetails.LinkTitle = iname.itemkey;

    this.flowservice.postLinkClick(linkClickDetails).subscribe((res) => {});
  }

  ngOnDestroy(): void {
    this.orgContextSub?.unsubscribe();
    const pageTime = this.pageTimeTrackerService.getPageTime() / 1000;

    // Clean up autoplay
    this.stopAutoplay();
    this.isAutoplayEnabled = false;

    if (this.autoplayMobileTooltipTimeout) {
      clearTimeout(this.autoplayMobileTooltipTimeout);
      this.autoplayMobileTooltipTimeout = null;
    }

    // Clean up review processing subject
    this.reviewsProcessingSubject.complete();

    // Disconnect MutationObserver
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }

    // Remove resize event listener
    if (this.resizeObserver) {
      window.removeEventListener("resize", this.resizeObserver);
      this.resizeObserver = null;
    }

    // Clear debounce timeout
    if (this.alignmentDebounceTimeout) {
      clearTimeout(this.alignmentDebounceTimeout);
      this.alignmentDebounceTimeout = null;
    }

    var email = "";
    // if (this.userData != null && this.userData != undefined &&
    //   this.userData.EmailAddress != null
    //   && this.userData.EmailAddress != undefined) { email = this.userData.EmailAddress; }
    // this.flowServiceService.updateFlowTime(email, pageTime, this.flowData.rowKey)
    //   .subscribe(response => {
    //   }, error => {
    //     console.error('Error:', error);
    //   });
  }

  ngOnInit() {
    this.pageTimeTrackerService.startTracking();
    this.flowServiceService.setScrollTop();
    this.viewUnloaded = true;
    this.videoPlayCounter.forEach((video) => {
      video.target.pause();
    });

    const width = window.innerWidth || document.body.clientWidth;
    this.dataSource = [];
    if (width <= 1024) {
      this.isMobileView = true;
      this.triggerMobileAutoplayTooltip();
    } else {
      this.isMobileView = false;
    }

    this.isFirstSlide = true;
    this.progressPercentage = 0;
    this.stepNumber = 0;
    this.isLastSlide = false;
    this.commentsForm = this.formbuilder.group({
      Comment: new UntypedFormControl("", Validators.required),
    });
    this.replyForm = this.formbuilder.group({
      reply: new UntypedFormControl("", Validators.required),
    });
    this.previousComment = [];

    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));

    console.log(this.userData);
    this.showNotificationCount = false;
    this.notificationCount = 4;

    this.stepText =
      "Check that you have all items required to complete the instruction";

    window.scrollTo(0, 0);

    this.embedMode =
      this.activateRouter.snapshot.data["embedMode"] === true ||
      this.activateRouter.snapshot.url[0]?.path === "embed";

    if (this.embedMode) {
      this.activateRouter.queryParamMap.subscribe((params) => {
        this.pendingEmbedView = (params.get("view") as EmbedViewType) || "full";
        const stepParam = params.get("step");
        this.pendingEmbedStep = stepParam ? parseInt(stepParam, 10) : null;
        if (this.flowData) {
          this.applyEmbedViewFromParams();
        }
      });
    }

    var notificationflowId = JSON.parse(
      localStorage.getItem("notificationflowId")
    );

    // Ignore parent route fragments in preview dialog (e.g. #step2),
    // otherwise preview UI may jump away from cover state.
    if (!this.openInDialog && !this.embedMode) {
      this.activateRouter.fragment.subscribe((fragment) => {
        if (fragment == null) return;
        if (fragment === "itemsRequired") {
          this.selectedStepIndex = -1;
        }
        if (fragment.startsWith("step")) {
          const stepNum = parseInt(fragment.replace("step", ""), 10);
          console.log(stepNum);
          console.log(!isNaN(stepNum) && stepNum >= 0);
          if (!isNaN(stepNum) && stepNum >= 0) {
            this.selectedStepIndex = stepNum - 1;
          }
        }
        const index = this.steps.indexOf(fragment);
        if (index >= 0) {
          this.selectedStepIndex = index - 1;
        }
      });
    }

    console.log(this.selectedStepIndex);
    // In preview mode, load specific version instead of using route params
    if (this.previewLogicalId && this.previewVersion != null) {
      this.loadFlowVersion(this.previewLogicalId, this.previewVersion);
    } else {
      this.activateRouter.paramMap.subscribe((params) => {
        console.log(params);
        const id = params.get("rowKey");
        if (id) {
          this.taskModeDefaultApplied = false;
          this.checkFlowAccessBeforeViewing(id);
        } else {
          const flowData = localStorage.getItem("flow");
          if (flowData) {
            // Use flowData if needed
            const parsedData = JSON.parse(flowData);
          }
        }
      });
    }

    this.resizeSrolling();
    
    // Set up debounced review processing
    this.reviewsProcessingSubject.pipe(
      debounceTime(100),
      distinctUntilChanged()
    ).subscribe(reviews => {
      this.processReviewsAsync(reviews);
    });
  }

  ngAfterViewInit() {
    // Update step scroll height after view initializes
    setTimeout(() => {
      this.updateStepScrollHeight();

      // Also listen for sidebar toggle events
      const sidebarToggle = document.querySelector(".menu-button");
      if (sidebarToggle) {
        sidebarToggle.addEventListener("click", () => {
          setTimeout(() => {
            this.updateStepScrollHeight();
            this.alignRecommendationsWithTitle();
          }, 350); // Wait for sidebar animation to complete
        });
      }

      // Watch for sidebar state changes using MutationObserver
      const mainContent = document.querySelector(".flow-main-content");
      if (mainContent) {
        this.mutationObserver = new MutationObserver(() => {
          // Debounce to prevent infinite loops
          if (this.alignmentDebounceTimeout) {
            clearTimeout(this.alignmentDebounceTimeout);
          }
          this.alignmentDebounceTimeout = setTimeout(() => {
            if (!this.isAligning) {
              this.updateStepScrollHeight();
              this.alignRecommendationsWithTitle();
            }
          }, 200); // Increased debounce time to 200ms
        });

        this.mutationObserver.observe(mainContent, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }

      // Watch for window resize with debouncing
      this.resizeObserver = () => {
        if (this.alignmentDebounceTimeout) {
          clearTimeout(this.alignmentDebounceTimeout);
        }
        this.alignmentDebounceTimeout = setTimeout(() => {
          if (!this.isAligning) {
            this.updateStepScrollHeight();
            this.alignRecommendationsWithTitle();
          }
        }, 200);
      };
      window.addEventListener("resize", this.resizeObserver);

      // Also align on initial load
      this.alignRecommendationsWithTitle();

      // iOS inline video playback fix
      this.setupIOSVideoPlayback();
    }, 500);
  }

  setupIOSVideoPlayback() {
    // Handle video element when it's available (may be conditionally rendered)
    const setupVideo = (video: HTMLVideoElement) => {
      video.setAttribute("playsinline", "true");
      video.setAttribute("webkit-playsinline", "true");
      video.setAttribute("x5-playsinline", "true");

      const tryAutoplay = () => {
        if (!this.isAutoplayEnabled) {
          return;
        }
        video.play().catch((error) => {
          console.log("Video autoplay prevented:", error);
        });
      };

      video.addEventListener("loadeddata", tryAutoplay);

      const playWhenVisible = () => {
        if (video.readyState >= 2) {
          tryAutoplay();
        }
      };

      video.addEventListener("loadedmetadata", playWhenVisible);
      video.addEventListener("canplay", playWhenVisible);
    };

    // Try to get video from ViewChild first
    if (this.videoPlayer?.nativeElement) {
      const videoEl = this.videoPlayer.nativeElement;
      videoEl.muted = false;
      setupVideo(videoEl);
    } else {
      // Fallback: query for video element (handles conditional rendering)
      const video = document.querySelector(
        ".main-video-player"
      ) as HTMLVideoElement;
      if (video) {
        setupVideo(video);
      } else {
        // Watch for video element to appear (for conditional rendering)
        const observer = new MutationObserver(() => {
          const videoElement = document.querySelector(
            ".main-video-player"
          ) as HTMLVideoElement;
          if (videoElement) {
            setupVideo(videoElement);
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }
    }
  }

  groupDataByGroupName() {
    if (!this.dataSource || this.dataSource.length === 0) {
      this.groupedData = {}; // Ensure no errors on empty or undefined data
      return;
    }

    this.groupedData = this.dataSource.reduce((acc, item) => {
      const group = item.groupName || ""; // Default group if missing
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(item);
      return acc;
    }, {} as Record<string, any[]>);
  }

  setFlowData() {
    console.log(this.userData);
    localStorage.setItem("flowData", JSON.stringify(this.flowData));
    localStorage.setItem("CreatorUserConsultation", null);
    if (this.userData != null) {
      if (
        this.userData.phoneNumber === null ||
        this.userData.phoneNumber === ""
      ) {
        this.toastr.show(
          "Please add phone no to procced with booking consult."
        );
      } else {
        console.log(this.flowData);
        // localStorage.setItem("CreatorUserConsultation", null);
        // localStorage.setItem("flowData", JSON.stringify(this.flowData));
        this.router.navigateByUrl("/bookconsultation");
      }
    } else {
      // localStorage.setItem("returnUrl", "/bookconsultation");
      // this.router.navigate(["/registration"]);
        this.authModalService.openModal('registration', "/bookconsultation");
    }
  }
  performFaqSearch(pageIndex) {
    this.noResultReturned = true;
    this.faqSelection = true;
    this.allFaqs = [];

    this.conversationHistory.push({
      question: this.question,
      answer: "Loading...",
      isGroupSelection: false,
    });

    var flowQueryModel = new FlowQueryModel({
      searchString: this.question,
      userEmail: this.email,
      pageIndex: pageIndex,
      partitionKey: this.flowData.rowKey,
    });

    this.userserviceService.searchInFaqs(flowQueryModel).subscribe((data) => {
      this.question = "";
      this.selectedGroup = null;
      this.noResultReturned = false;
      if (data.allFaqs.length > 0) {
        this.allFaqs = [];
        this.faqSelection = false;
        data.allFaqs.forEach((element) => {
          console.log(element);
          if (element != null && element.answer) {
            this.supportFlowFaqs = element;
            this.conversationHistory[
              this.conversationHistory.length - 1
            ].answer = this.supportFlowFaqs.answer;
          } else {
            this.conversationHistory[
              this.conversationHistory.length - 1
            ].answer =
              "Sorry, I am not able to understand your question. Please type it again.";
          }
          //this.supportFlowFaqs.push(element);
          //this.selectedFaq.push(element);
        });
      } else {
        this.conversationHistory[this.conversationHistory.length - 1].answer =
          "Apologies, I may not have understood your question correctly. Could you please clarify? If I still don't get it, feel free to leave your question in the comment section!";
      }
    });
  }

  recordPageView() {
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var getPageViewDetails = {
      ContentId: this.flowData.rowKey,
      ContentTitle: this.flowData.title,
      UserEmail: email,
      ContentType: this.flowData.type,
      ContentUrl: this.flowData.url,
    };

    this.flowServiceService
      .postPageView(getPageViewDetails)
      .subscribe((res) => {});
  }

  showFlowImage(imageSource) {
    localStorage.removeItem("itemsRequiredImageToShow");
    localStorage.setItem("flowImageToShow", imageSource);
    this.dialog.open(ShowFlowImageDialogComponent, {
      panelClass: ["media-dialog-pane", "media-dialog"],
      backdropClass: "custom-backdrop",
      maxWidth: "95vw",
      width: "auto",
      maxHeight: "95vh",
      height: "auto",
      autoFocus: false,
      restoreFocus: false,
    });
  }

  checkFlowAccessBeforeViewing(flowId) {
    if (!flowId) {
      this.getFlowDetails(flowId);
      return;
    }

    this.geoAccessRetryUsed = false;
    const deviceId = getOrCreateDeviceId();
    const cached = getCachedGeoPosition();

    // Public flows must stay viewable without a GPS prompt. Guests load first
    // with cached coords; if geo is required, flowByFlowId returns 403 and we retry.
    if (!this.userData) {
      this.getFlowDetails(flowId, {
        deviceId,
        latitude: cached?.latitude,
        longitude: cached?.longitude,
        accuracy: cached?.accuracy,
      });
      return;
    }

    const userEmail = this.userData?.emailAddress || "";

    getCurrentPositionOptional().then((coords) => {
      this.flowServiceService
        .checkFlowAccess(flowId, userEmail, {
          deviceId,
          latitude: coords?.latitude,
          longitude: coords?.longitude,
          accuracy: coords?.accuracy,
        })
        .subscribe(
          (response) => {
            const isOwner = !!(response.isOwner ?? response.IsOwner);
            const hasAccess = !!(response.hasAccess ?? response.HasAccess);
            const denialCode = response.denialCode || response.DenialCode || "";
            const sentCoords = coords?.latitude != null && coords?.longitude != null;

            if (isOwner) {
              this.getFlowDetails(flowId, {
                deviceId,
                latitude: coords?.latitude,
                longitude: coords?.longitude,
                accuracy: coords?.accuracy,
              });
              return;
            }

            if (
              !hasAccess &&
              shouldRetryAccessWithLocation(denialCode, sentCoords) &&
              this.retryViewWithLocation(flowId)
            ) {
              return;
            }

            if (!hasAccess) {
              this.showAccessBlocker(
                accessBlockTypeFromDenial(
                  denialCode,
                  response.isPrivate ?? response.IsPrivate,
                  response.isRestricted ?? response.IsRestricted
                ),
                flowId,
                response
              );
            } else {
              this.getFlowDetails(flowId, {
                deviceId,
                latitude: coords?.latitude,
                longitude: coords?.longitude,
                accuracy: coords?.accuracy,
              });
            }
          },
          (error) => {
            console.error("Error checking flow access:", error);
            if (error?.status === 403) {
              const denial = denialFromHttpError(error);
              const sentCoords = coords?.latitude != null && coords?.longitude != null;
              if (
                shouldRetryAccessWithLocation(denial.code, sentCoords) &&
                this.retryViewWithLocation(flowId)
              ) {
                return;
              }
              this.showAccessBlocker(
                accessBlockTypeFromDenial(denial.code),
                flowId,
                {
                  denialCode: denial.code,
                  denialMessage: denial.message,
                  isRestricted: this.inferFlowIsRestricted(),
                  isPrivate: this.inferFlowIsPrivate(),
                }
              );
              return;
            }
            if (error?.status === 404) {
              this.flowNotFound = true;
              this.isInitialLoading = false;
              this.flowData = null;
              this.cdr.markForCheck();
              return;
            }
            this.getFlowDetails(flowId, {
              deviceId,
              latitude: coords?.latitude,
              longitude: coords?.longitude,
              accuracy: coords?.accuracy,
            });
          }
        );
    });
  }

  private retryViewWithLocation(flowId: string): boolean {
    if (this.geoAccessRetryUsed || !flowId) {
      return false;
    }
    this.geoAccessRetryUsed = true;
    getCurrentPositionOptional(15000).then((coords) => {
      if (!coords) {
        this.showAccessBlocker("advanced", flowId, {
          denialCode: "GEO_LOCATION_REQUIRED",
          denialMessage:
            "Allow location access so we can confirm you are inside the allowed area.",
        });
        return;
      }
      this.getFlowDetails(flowId, {
        deviceId: getOrCreateDeviceId(),
        latitude: coords.latitude,
        longitude: coords.longitude,
        accuracy: coords.accuracy,
      });
    });
    return true;
  }

  showAccessBlocker(type: string, rowKey: string, accessResponse: any = null) {
    if (this.isAccessDialogOpen) {
      return;
    }
    const pending = peekPendingFlowAccessRequest(rowKey);
    if (pending) {
      clearPendingFlowAccessRequest();
      accessResponse = { ...(accessResponse || {}), ...pending };
    }
    this.isAccessDialogOpen = true;
    localStorage.setItem("flowDataKey", JSON.stringify({ rowKey: rowKey }));

    const dialogRef = this.dialog.open(FlowAccessBlockerComponent, {
      panelClass: "dialoguebox",
      width: "90%",
      maxWidth: "500px",
      maxHeight: "90vh",
      minHeight: "200px",
      disableClose: true,
      hasBackdrop: true,
      backdropClass: "custom-backdrop",
      autoFocus: false,
      restoreFocus: false,
      data: {
        flowId: rowKey,
        isPrivate:
          accessResponse?.isPrivate ??
          accessResponse?.IsPrivate ??
          type === "private",
        isRestricted:
          accessResponse?.isRestricted ??
          accessResponse?.IsRestricted ??
          (type === "restricted" ||
            (type === "advanced" &&
              !(accessResponse?.isPrivate ?? accessResponse?.IsPrivate))),
        isAdvanced: type === "advanced" || !!accessResponse?.isAdvanced,
        hasAccess: false,
        denialCode:
          accessResponse?.denialCode || accessResponse?.DenialCode || "",
        denialMessage:
          accessResponse?.denialMessage ||
          accessResponse?.DenialMessage ||
          "",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isAccessDialogOpen = false;
      if (result == "request_access") {
        this.toastr.success("Access request submitted successfully!");
      } else if (result == "go_home") {
        this.router.navigate(["/"]);
      } else if (result?.action === "share_location" && result.coords) {
        this.geoAccessRetryUsed = true;
        this.getFlowDetails(rowKey, {
          deviceId: getOrCreateDeviceId(),
          latitude: result.coords.latitude,
          longitude: result.coords.longitude,
          accuracy: result.coords.accuracy,
        });
      }
    });
  }

  private inferFlowIsRestricted(): boolean {
    const src = this.flowData || {};
    const accessType = String(src.accessType || src.AccessType || "").toLowerCase();
    return accessType === "restricted";
  }

  private inferFlowIsPrivate(): boolean {
    const src = this.flowData || {};
    const accessType = String(src.accessType || src.AccessType || "").toLowerCase();
    return accessType === "private";
  }

  showAccessRequestDialog() {
    const dialogRef = this.dialog.open(FlowAccessRequestComponent, {
      panelClass: ["access-request-dialog", "access-request-pane"],
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toastr.success("Access request submitted successfully!");
      }
      // Stay on the same page. Do not navigate away automatically.
    });
  }

  getFlowDetails(flowId, accessContext?: {
    deviceId?: string;
    latitude?: number;
    longitude?: number;
    accuracy?: number;
  }) {
    this.noResultReturned = true;
    this.isInitialLoading = true;
    const sentCoords =
      accessContext?.latitude != null && accessContext?.longitude != null;
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    this.flowServiceService
      .getFlowById(flowId, email, {
        deviceId: accessContext?.deviceId || getOrCreateDeviceId(),
        latitude: accessContext?.latitude,
        longitude: accessContext?.longitude,
        accuracy: accessContext?.accuracy,
      })
      .subscribe(async (data) => {
        this.noResultReturned = false;
        const flowPayload = data?.flows ?? data?.Flows;
        console.log(flowPayload);
        if (flowPayload != null) {
          this.flowNotFound = false;
          this.flowData = this.normalizeFlowModelForRendering(flowPayload);
          // Normalize TaggedItems (capital T from API) to taggedItems (lowercase) in all steps
          // Also normalize itemKey (capital K) to itemkey (lowercase) for compatibility
          // Normalize IsSafetyCritical and SafetyInstructions from API
          if (this.flowData.steps && Array.isArray(this.flowData.steps)) {
            this.flowData.steps.forEach(step => {
              if (step.TaggedItems && !step.taggedItems) {
                step.taggedItems = step.TaggedItems;
              }
              // Normalize itemKey property in tagged items
              if (step.taggedItems && Array.isArray(step.taggedItems)) {
                step.taggedItems.forEach(item => {
                  if (item.itemKey && !item.itemkey) {
                    item.itemkey = item.itemKey;
                  }
                });
              }
              // Normalize safety critical fields from API
              if (step.IsSafetyCritical !== undefined && step.isSafetyCritical === undefined) {
                step.isSafetyCritical = step.IsSafetyCritical;
              }
              if (step.SafetyInstructionsTitle && !step.safetyInstructionsTitle) {
                step.safetyInstructionsTitle = step.SafetyInstructionsTitle;
              }
              if (step.SafetyInstructionsDescription && !step.safetyInstructionsDescription) {
                step.safetyInstructionsDescription = step.SafetyInstructionsDescription;
              }
            });
          }
          this.CheckIsUserFollowing();
          this.setFlowDetails();
          this.recordPageView();
          this.isInitialLoading = false;
          this.loadComments(); // Load comments when flow is loaded
          this.loadLatestVersion(); // Fetch latest version from version history
          // Load or reset step progress
          if (!this.shouldResetStepProgressOnLoad) {
            this.loadStepProgress(); // Restore step progress for logged-in users
            this.loadStepBookmarks(); // Restore bookmarked steps for logged-in users
          } else {
            // Explicitly reset visited steps so completion % starts from 0%
            this.visitedSteps = new Set();
            this.bookmarkedSteps = new Set();
            this.hasRestartedAfterCompletion = false;
          }
          
          // Trigger change detection after flow data is loaded
          this.cdr.markForCheck();

          // Access was already decided by checkFlowAccess / flowByFlowId (403).
          // Do not re-block here: RestrictedAccessType is not on the flow payload,
          // so a logged-out LinkAccess viewer would incorrectly get the modal.

          // Check transfer ownership status if user is the owner
          this.checkTransferOwnershipOnPageLoad();
        } else {
          // Flow not available: stop skeleton and show inline message instead of redirect
          this.flowNotFound = true;
          this.isInitialLoading = false;
          this.flowData = null;
          this.cdr.markForCheck();
        }
        
        // Trigger change detection after flow data processing
        this.cdr.markForCheck();
      }, (error) => {
        this.noResultReturned = false;
        this.isInitialLoading = false;
        if (error?.status === 403) {
          const denial = denialFromHttpError(error);
          if (
            shouldRetryAccessWithLocation(denial.code, sentCoords) &&
            this.retryViewWithLocation(flowId)
          ) {
            return;
          }
          this.showAccessBlocker(
            accessBlockTypeFromDenial(denial.code),
            flowId,
            {
              denialCode: denial.code,
              denialMessage: denial.message,
              isRestricted: this.inferFlowIsRestricted(),
              isPrivate: this.inferFlowIsPrivate(),
            }
          );
          this.cdr.markForCheck();
          return;
        }
        if (error?.status === 404) {
          this.flowNotFound = true;
          this.flowData = null;
          this.cdr.markForCheck();
          return;
        }
        this.flowNotFound = true;
        this.flowData = null;
        this.cdr.markForCheck();
      });

    this.getSupportFaqs(flowId);
  }

  getViewAccessKind(): "public" | "private" | "private-link" | "restricted" {
    const src = this.flowData || {};
    const accessType = String(src.accessType || src.AccessType || "").toLowerCase();
    const restrictedType = String(
      src.restrictedAccessType || src.RestrictedAccessType || ""
    );
    const users = src.restrictedAccessFlows || src.RestrictedAccessFlows || [];
    const hasUsers = Array.isArray(users) && users.length > 0;
    const hasAdvanced = !!(
      src.enforceNetwork ||
      src.EnforceNetwork ||
      src.enforceGeo ||
      src.EnforceGeo ||
      src.enforceDevice ||
      src.EnforceDevice ||
      src.enforceCompanyEmail ||
      src.EnforceCompanyEmail
    );

    if (accessType === "public") {
      return "public";
    }
    if (accessType === "private") {
      return "private";
    }
    if (accessType === "restricted") {
      if (
        hasAdvanced ||
        hasUsers ||
        restrictedType === "SelectedUsers" ||
        restrictedType.toLowerCase() !== "linkaccess"
      ) {
        return "restricted";
      }
      return "private-link";
    }
    return "public";
  }

  getViewAccessBadge(): string {
    const kind = this.getViewAccessKind();
    if (kind === "restricted") {
      return "Restricted";
    }
    if (kind === "public") {
      return "Public";
    }
    return "Private";
  }

  getViewAccessIcon(): string {
    const kind = this.getViewAccessKind();
    if (kind === "public") {
      return "public";
    }
    if (kind === "restricted") {
      return "group";
    }
    if (kind === "private-link") {
      return "link";
    }
    return "lock";
  }

  getViewAccessMark(): string {
    const kind = this.getViewAccessKind();
    if (kind === "private") {
      return "Only you";
    }
    if (kind === "private-link") {
      return "Link";
    }
    return "";
  }

  getCurrentAccessLabel(): string {
    return this.getViewAccessBadge();
  }

  saveFlowToServerAccessLevel(AccessType) {
    console.log(this.flowData);
    (this.flowData.accessType = AccessType),
      (this.flowData.customerEmail = this.userData.emailAddress);
    this.flowData.uniqueId = this.flowData.uniqueId;
    this.flowData.searchKeyWords = Array.isArray(this.flowData.searchKeyWords)
      ? this.flowData.searchKeyWords.join(", ")
      : this.flowData.searchKeyWords ?? "";
    if (this.userData != null) {
      this.noResultReturned = true;
      this.flowServiceService
        .saveFlowToServerAccessLevel(this.flowData, this.userData.emailAddress)
        .subscribe((data) => {
          console.log(data);
          this.flowData.accessType = data.AccessType;
          this.toastr.success(
            `Flow access type updated to ${AccessType} successfully.`
          );
          this.noResultReturned = false;
        });
    }
  }

  restrictedAccessPage(_accessType?: string) {
    if (this.isEnhancedDialogOpen) {
      return;
    }
    this.isEnhancedDialogOpen = true;
    localStorage.setItem("flowModel", JSON.stringify(this.flowData));
    const dialogRef = this.dialog.open(EnhancedRestrictedAccessComponent, {
      panelClass: "dialoguebox",
      data: { mode: "update" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.isEnhancedDialogOpen = false;
      if (result) {
        const accessType =
          result.accessType || result.AccessType || this.flowData.accessType;
        this.flowData.accessType = accessType;
        this.flowData.AccessType = accessType;
        this.flowData.restrictedAccessType =
          result.restrictedAccessType || result.RestrictedAccessType;
        this.flowData.RestrictedAccessType = this.flowData.restrictedAccessType;
        this.flowData.isSearchHidden =
          result.isSearchHidden ?? result.IsSearchHidden;
        this.flowData.enforceNetwork =
          result.enforceNetwork ?? result.EnforceNetwork;
        this.flowData.enforceGeo = result.enforceGeo ?? result.EnforceGeo;
        this.flowData.enforceDevice =
          result.enforceDevice ?? result.EnforceDevice;
        this.flowData.enforceCompanyEmail =
          result.enforceCompanyEmail ?? result.EnforceCompanyEmail;
        this.flowData.allowedCidrs =
          result.allowedCidrs ?? result.AllowedCidrs ?? this.flowData.allowedCidrs;
        this.flowData.AllowedCidrs = this.flowData.allowedCidrs;
        this.flowData.allowedEmailDomains =
          result.allowedEmailDomains ??
          result.AllowedEmailDomains ??
          this.flowData.allowedEmailDomains;
        this.flowData.AllowedEmailDomains = this.flowData.allowedEmailDomains;
        this.flowData.allowedDeviceIds =
          result.allowedDeviceIds ??
          result.AllowedDeviceIds ??
          this.flowData.allowedDeviceIds;
        this.flowData.AllowedDeviceIds = this.flowData.allowedDeviceIds;
        this.flowData.geoFenceJson =
          result.geoFenceJson ?? result.GeoFenceJson ?? this.flowData.geoFenceJson;
        this.flowData.GeoFenceJson = this.flowData.geoFenceJson;
        this.flowData.restrictedAccessFlows =
          result.restrictedAccessFlows ||
          result.RestrictedAccessFlows ||
          this.flowData.restrictedAccessFlows;
        this.toastr.success(
          `Flow access type updated to ${accessType} successfully.`
        );
      }
    });
  }

  flowByCategory(category) {
    // var categories = JSON.parse(
    //   localStorage.getItem("allcategoryflowsforviewprofilepage")
    // );

    // var categoryFlows = categories.filter((c) => c.CategoryName == category)[0];
    // localStorage.setItem("flowByCategoryCategoryName", category);
    // this.dataService.flowByCategorieschangeMessage(categoryFlows.FlowModels);
    localStorage.setItem("flowByCategoryCategoryName", category);
    this.router.navigate(["/guide-by-category"]);
  }
  transferOwnership(flowData) {
    if (!hasContentCreationPlanAccess(this.userData)) {
      this.toastr.info(
        "A Creator or Business plan is required to transfer ownership."
      );
      return;
    }
    // First check if the flow is part of any bundle
    this.checkFlowBundleStatus(flowData.rowKey);
  }

  checkFlowBundleStatus(contentId: string) {
    var flowModel = {
      rowKey: contentId,
      partitionKey: this.flowData.customerEmail,
    };

    this.bundleService.getBundlesByFlowId(flowModel, "0").subscribe({
      next: (data) => {
        if (data && data.length > 0) {
          // Store bundles data for later use
          this.bundles = data;
          this.toastr.info(
            "Please remove this guide from all guide packs before proceeding with transfer"
          );
          // Flow is part of a bundle, show warning dialog
          // this.showBundleTransferWarningDialog(data);
        } else {
          // Flow is not part of any bundle, proceed with normal transfer ownership check
          this.checkTransferOwnershipStatus(contentId);
        }
      },
      error: (error) => {
        console.error("Error checking bundle status:", error);
        // If error occurs, proceed with normal transfer ownership check (fail-safe)
        this.checkTransferOwnershipStatus(contentId);
      },
    });
  }

  showBundleTransferWarningDialog(bundles: any[]) {
    const dialogRef = this.dialog.open(BundleTransferWarningDialogComponent, {
      panelClass: "dialoguebox",
      data: { bundles: bundles },
      hasBackdrop: true,
      backdropClass: "non-transparent-backdrop",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "remove-from-bundle") {
        // User chose to remove flow from bundle, proceed with transfer
        this.removeFlowFromBundleAndTransfer();
      } else if (result === "proceed-without-removal") {
        // User chose to proceed without removing from bundle (this shouldn't happen in normal flow)
        this.checkTransferOwnershipStatus(this.flowData.rowKey);
      }
      // If result is undefined/null, user cancelled the operation
    });
  }

  removeFlowFromBundleAndTransfer() {
    // Show user instructions on how to remove flow from bundle
    const confirmDialog = this.dialog.open(
      ConfirmBundleRemovalDialogComponent,
      {
        panelClass: "dialoguebox",
        data: {
          bundles: this.bundles,
          flowData: this.flowData,
        },
        hasBackdrop: true,
        backdropClass: "non-transparent-backdrop",
      }
    );

    confirmDialog.afterClosed().subscribe((result) => {
      if (result === "proceed") {
        // User confirmed they will handle bundle removal manually
        // Check transfer ownership status before proceeding with any transfer actions
        this.toastr.info(
          "Please remove this guide from all guide packs before proceeding with transfer"
        );
        this.checkTransferOwnershipStatus(this.flowData.rowKey);
      }
    });
  }

  /**
   * Check if there are any active transfer ownership requests for the current flow
   * @returns Promise<boolean> - true if there are active requests, false otherwise
   */
  hasActiveTransferRequests(): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.flowData || !this.flowData.rowKey) {
        resolve(false);
        return;
      }

      this.flowServiceService
        .getTransferOwnershipByContentId(this.flowData.rowKey)
        .subscribe({
          next: (data) => {
            if (data && data.length > 0) {
              // Check if there's any request with status other than "Approved", "Rejected", or "Cancelled"
              const activeRequest = data.find(
                (request: any) =>
                  request.requestStatus !== "Approved" &&
                  request.requestStatus !== "Rejected" &&
                  request.requestStatus !== "Cancelled"
              );
              resolve(!!activeRequest);
            } else {
              resolve(false);
            }
          },
          error: (error) => {
            console.error("Error checking active transfer requests:", error);
            resolve(false); // On error, assume no active requests (fail-safe)
          },
        });
    });
  }

  checkTransferOwnershipStatus(contentId: string) {
    console.log(
      `Checking transfer ownership status for contentId: ${contentId}`
    );

    this.flowServiceService
      .getTransferOwnershipByContentId(contentId)
      .subscribe((data) => {
        if (data && data.requestStatus != null) {
          // Check if there's any request with status other than "Approved", "Rejected", or "Cancelled"
          // Statuses that indicate an active/ongoing request: "Pending", "ReworkRequested", "ReworkAccepted", etc.
          // Statuses that indicate a completed request: "Approved", "Rejected", "Cancelled"
          const activeRequest =
            data.requestStatus !== "Approved" &&
            data.requestStatus !== "Rejected" &&
            data.requestStatus !== "Cancelled"
              ? data
              : null;

          if (activeRequest) {
            console.log(
              `Found active transfer request with status: ${activeRequest.requestStatus}`
            );
            // Show info message about transfer request in progress and BLOCK further actions
            this.toastr.warning(
              `Transfer request is already in progress with status: ${activeRequest.requestStatus}. Please wait for the current request to be completed before initiating a new one.`
            );
            this.hasActiveTransferRequest = true; // Set the flag to disable transfer actions
            return; // Exit early - do not proceed with any transfer actions
          } else {
            console.log(
              "No active transfer requests found, all requests are completed"
            );
            this.hasActiveTransferRequest = false; // Clear the flag to allow transfer actions
            this.openTransferOwnershipDialog();
          }
        } else {
          console.log("No transfer ownership records found for this content");
          this.openTransferOwnershipDialog();
        }

        // If no active request found, proceed with existing logic (open transfer ownership dialog)
        console.log("Proceeding to open transfer ownership dialog");
      });
  }

  checkTransferOwnershipOnPageLoad() {
    // Only check if user is logged in and is the owner of the flow
    if (
      this.userData &&
      this.flowData &&
      this.userData.emailAddress === this.flowData.customerEmail
    ) {
      console.log(
        `Checking transfer ownership status on page load for flow: ${this.flowData.rowKey}`
      );

      this.flowServiceService
        .getTransferOwnershipByContentId(this.flowData.rowKey)
        .subscribe({
          next: (data) => {
            console.log("Transfer ownership response on page load:", data);

            if (data && data.length > 0) {
              // Check if there's any request with status other than "Approved", "Rejected", or "Cancelled"
              // Statuses that indicate an active/ongoing request: "Pending", "ReworkRequested", "ReworkAccepted", etc.
              // Statuses that indicate a completed request: "Approved", "Rejected", "Cancelled"
              const activeRequest =
                data.requestStatus !== "Approved" &&
                data.requestStatus !== "Rejected" &&
                data.requestStatus !== "Cancelled";

              if (activeRequest) {
                console.log(
                  `Found active transfer request on page load with status: ${data.requestStatus}`
                );
                // Show warning message about transfer request in progress
                this.toastr.warning(
                  `Transfer request is already in progress with status: ${data.requestStatus}. Please wait for the current request to be completed before initiating a new one.`
                );
                this.hasActiveTransferRequest = true; // Set the flag to disable transfer actions
              } else {
                console.log(
                  "No active transfer requests found on page load, all requests are completed"
                );
                this.hasActiveTransferRequest = false; // Clear the flag to allow transfer actions
              }
            } else {
              console.log(
                "No transfer ownership records found on page load for this content"
              );
              this.hasActiveTransferRequest = false; // Clear the flag to allow transfer actions
            }
            // If no data or all requests are completed, take no action (as requested)
          },
          error: (error) => {
            console.error(
              "Error checking transfer ownership status on page load:",
              error
            );
            // If error occurs, take no action (fail-safe)
          },
        });
    } else {
      console.log(
        "Skipping transfer ownership check on page load - user not logged in or not flow owner"
      );
    }
  }

  openTransferOwnershipDialog() {
    localStorage.setItem("flowModel", JSON.stringify(this.flowData));
    const dialogRef = this.dialog.open(TransferOwnershipComponent, {
      panelClass: "dialoguebox",
    });
    dialogRef.afterClosed().subscribe((result) => {
      // if (result) {
      //   this.toastr.success("Successfully ownership is transfer initiated");
      // }
    });
  }

  openTaskMode(replaceUrl = false): void {
    if (!this.orgContextService.isOrganizationMode()) return;
    const rowKey = this.flowData?.rowKey || this.flowData?.RowKey;
    const title =
      this.activateRouter.snapshot.paramMap.get("title") ||
      this.generateUrlSlug(this.flowData?.title || this.flowData?.Title || "wi");
    if (!rowKey) {
      return;
    }
    const pack = this.activateRouter.snapshot.queryParamMap.get("pack");
    this.router.navigate(["/perform", title, rowKey], {
      replaceUrl,
      queryParams: pack ? { pack } : undefined,
    });
  }

  Editflow(flowData) {
    const openEditor = (data: any) => {
      writeGuideEditStorage(data);
      this.flowNavigationService.captureReturnPath();
      this.router.navigate(["/create-guide"]);
    };

    // Viewers see the published version; editing must continue from the unpublished edits.
    if (!(flowData?.hasPendingDraft ?? flowData?.HasPendingDraft)) {
      openEditor(flowData);
      return;
    }

    const email = this.userData?.emailAddress || "";
    this.flowServiceService
      .getFlowById(flowData.rowKey, email, { draft: true })
      .subscribe({
        next: (res) => {
          const draft = res?.flows ?? res?.Flows;
          openEditor(draft ? this.normalizeFlowModelForRendering(draft) : flowData);
        },
        error: () => openEditor(flowData),
      });
  }

  showToast() {
    this.toastr.success("Flow Liked");
  }

  showToastForUnlike() {
    this.toastr.success("Flow Unliked");
  }

  showToastForDelete() {
    this.toastr.success("Flow successfully Deleted");
  }

  setFlowDetails() {
    var lightBoxImage;
    this.showVideoFromFile(this.flowData.url);
    // this.imageSource = this.flowData.url;
    // this.imageSource = lightBoxImage;
    localStorage.setItem("flowUrl", JSON.stringify(this.imageSource));
    this.flowId = this.flowData.rowKey;
    this.description = this.flowData.description;
    this.posterImageSource = this.flowData.videoThumbNailUrl;
    this.nextCount = 0;
    this.itemsRequired = 0;
    this.stepCount = 0;
    var stepIncrementCount = 0;
    this.flowData.searchKeyWords = this.flowData.searchKeyWords
      ? this.flowData.searchKeyWords.split(", ").map((k) => k.trim())
      : [];
    localStorage.setItem("flow", JSON.stringify(this.flowData));
    this.titleandmetaserviceService.setTitle(
      this.flowData.title + "-Flowchest"
    );
    this.titleandmetaserviceService.setKeywords(this.flowData.searchKeyWords);
    const url = window.location.href;
    // this.titleandmetaserviceService.setCanonicalUrl(url);

    if (this.flowData === "default message") {
      this.flowData = JSON.parse(localStorage.getItem("recentflow"));
    }

    if (this.flowData.components.length > 0) {
      this.dataSource = this.flowData.components;
      this.groupDataByGroupName();
      stepIncrementCount = 2;
    } else {
      stepIncrementCount = 1;
    }

    localStorage.removeItem("pageIndex");
    localStorage.setItem("pageIndex", "0");
    this.getBundles("0");
    this.loadEmbeddedInBlogs();
    const steps = this.flowData.steps.length + stepIncrementCount;
    this.progressBy = 100 / steps;
    this.progressPercentage = 100 / steps;

    if (this.flowData.steps.length > 0) {
      this.IsSteps = true;
      this.loadSteps(this.flowData.steps);
    }

    if (this.userData != null) {
      if (this.flowData.isLiked === "liked") {
        this.likecolor = true;
      } else if (this.flowData.isLiked === "unliked") {
        this.likecolor = false;
      } else {
        this.likecolor = false;
      }
    } else {
      // Not logged in: always show unliked state
      this.likecolor = false;
    }
    this.likeCount = this.flowData.likeCount;

    if (this.flowData.isSaved === true) {
      this.bookmarkcolor = "black";
      this.saveCount = this.flowData.saveCount;
    } else {
      this.bookmarkcolor = "gray";
      this.saveCount = this.flowData.saveCount;
    }

    this.viewsCount = this.flowData.viewsCount;
    if (this.flowData.viewsCount > 1) {
      this.viewText = "Views";
    } else this.viewText = "View";

    // this.isFlowLiked();

    this.applyStoredUserProfilePicture();
    this.updateFlowAccessFromStoredUser();
    this.GetFlowUserData();
    // this.getProfilepic();
    //this.noResultReturned = false;

    this.openTaskModeByDefault();

    if (this.userData != null && this.userData.enableDefaultView) {
      console.log(this.selectedStepIndex);
      this.onToggleChange({ checked: this.userData.enableDefaultView });
    } else {
      if (this.embedMode) {
        this.applyEmbedViewFromParams();
      } else if (this.selectedStepIndex != -2) {
        console.log(this.selectedStepIndex);
        // this.selectedStepIndex -= this.selectedStepIndex;
        this.selectStepAdvanced(this.selectedStepIndex);
      }
    }
  }

  InAppropriate() {
    if (this.userData === null) {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
 this.authModalService.openModal('registration', this.router.url);
    } else {
      //this.router.navigate(["/in-Appropriate"]);
      localStorage.setItem("flowData", JSON.stringify(this.flowData));
      const dialogRef = this.dialog.open(InAppropriateComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {});
    }
  }
  checkoutconfirmpopup() {
    if (this.userData === null) {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
 this.authModalService.openModal('registration', this.router.url);
    } else {
      //this.router.navigate(["/in-Appropriate"]);
      console.log(this.tempFlows);
      console.log(this.flowData);
      localStorage.setItem("flowData", JSON.stringify(this.flowData));
      localStorage.setItem("BundleListToShare", JSON.stringify(this.tempFlows));
      const dialogRef = this.dialog.open(CheckoutNavigatorComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {});
    }
  }

  openDialog() {
    this.dialog.open(DialogExampleComponent, {
      height: "180px",
      width: "250px",
    });
  }

  deleteFlow() {
    var flowModel = {
      rowKey: this.flowData.rowKey,
      CustomerEmail: this.userData.emailAddress,
      FlowStatus: "Approved",
    };

    //this.noResultReturned = true;
    //
    var navigateTo = JSON.parse(localStorage.getItem("navigateTo"));
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (this.userData != null) {
      this.flowServiceService
        .deleteFlow(flowModel)

        .subscribe((data) => {
          //
          //this.noResultReturned = false;
          this.showToastForDelete();
          if (data.Deleted) {
            this.router.navigate(["/" + navigateTo]);
          }
        });
    }
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.resize(event);
  }

  resize(event?) {
    const width =
      event?.target?.innerWidth ??
      event?.srcElement?.outerWidth ??
      window.innerWidth ??
      document.body.clientWidth;

    const wasMobile = this.isMobileView;
    this.isMobileView = width <= 1024;

    if (this.isMobileView) {
      if (!wasMobile) {
        this.triggerMobileAutoplayTooltip();
      }
    } else {
      this.showAutoplayMobileTooltip = false;
    }

    this.updateStepScrollHeight();
  }

  updateStepScrollHeight() {
    // Only update on desktop (not mobile)
    if (this.isMobileView) {
      return;
    }

    // Prevent recursive calls
    if (this.isAligning) {
      return;
    }

    setTimeout(() => {
      const videoSection = this.videoPlayerSection?.nativeElement;
      const stepScroll = this.stepScrollContainer?.nativeElement;

      if (videoSection && stepScroll) {
        // Get the actual height of the video player section (img-wrap with padding-bottom)
        const imgWrap = videoSection.querySelector(".img-wrap");
        if (imgWrap) {
          // The img-wrap uses padding-bottom: 56.25% for 16:9 aspect ratio
          // Get the computed height which accounts for the padding-bottom
          const height = imgWrap.offsetHeight;

          // Set the max-height of step-scroll to extend slightly beyond video height
          // Add extra space to better match the video/image div end
          if (height > 0) {
            const extraHeight = 80; // Additional height to extend beyond video
            const newHeight = height + extraHeight;
            const currentHeight = parseInt(stepScroll.style.maxHeight || "0");
            
            // Only update if the value actually changed (prevents infinite loop)
            if (Math.abs(currentHeight - newHeight) > 1) {
              stepScroll.style.setProperty(
                "max-height",
                `${newHeight}px`,
                "important"
              );
            }
          }
        } else {
          // Fallback: try to get height from video-player-section
          const sectionHeight = videoSection.offsetHeight;
          if (sectionHeight > 0) {
            const extraHeight = 80; // Additional height to extend beyond video
            const newHeight = sectionHeight + extraHeight;
            const currentHeight = parseInt(stepScroll.style.maxHeight || "0");
            
            // Only update if the value actually changed (prevents infinite loop)
            if (Math.abs(currentHeight - newHeight) > 1) {
              stepScroll.style.setProperty(
                "max-height",
                `${newHeight}px`,
                "important"
              );
            }
          }
        }
      }

      // Also align recommendations section with title (only if not already aligning)
      if (!this.isAligning) {
        setTimeout(() => {
          this.alignRecommendationsWithTitle();
        }, 50);
      }
    }, 100);
  }

  alignRecommendationsWithTitle() {
    // Only update on desktop (not mobile)
    if (this.isMobileView) {
      return;
    }

    // Prevent recursive calls
    if (this.isAligning) {
      return;
    }

    this.isAligning = true;

    const videoMetadata = this.videoMetadata?.nativeElement;
    const recommendationsSection = this.recommendationsSection?.nativeElement;
    const sidebar = recommendationsSection?.closest(".flow-sidebar");

    if (videoMetadata && recommendationsSection && sidebar) {
      // Get the video title element (h1.video-title) inside video-metadata
      const videoTitle = videoMetadata.querySelector(
        ".video-title"
      ) as HTMLElement;
      const recommendationsTitle = recommendationsSection.querySelector(
        "h2"
      ) as HTMLElement;

      if (videoTitle && recommendationsTitle) {
        // Get the position of the video title relative to the viewport
        const titleRect = videoTitle.getBoundingClientRect();
        const sidebarRect = sidebar.getBoundingClientRect();
        const recommendationsTitleRect =
          recommendationsTitle.getBoundingClientRect();

        // Calculate the offset from the top of the sidebar to where the video title BOTTOM is
        // We want to align the bottom of both titles (baseline alignment)
        const videoTitleBottomFromSidebar = titleRect.bottom - sidebarRect.top;

        // Get the current position of the recommendations h2 relative to its section
        const recommendationsTitleTopFromSection =
          recommendationsTitleRect.top -
          recommendationsSection.getBoundingClientRect().top;
        const recommendationsTitleHeight = recommendationsTitleRect.height;

        // Get the step-navigation height to account for it
        const stepNavigation = sidebar.querySelector(
          ".step-navigation"
        ) as HTMLElement;
        const stepNavHeight = stepNavigation ? stepNavigation.offsetHeight : 0;
        const stepNavMarginBottom = 24; // margin-bottom of step-navigation

        // Calculate where the recommendations section should start
        // We want the BOTTOM of the h2 title to align with the BOTTOM of the video title
        // So we need to position the section such that its h2 bottom aligns with the video title bottom
        const recommendationsTitleBottomFromSection =
          recommendationsTitleTopFromSection + recommendationsTitleHeight;
        const sectionTop =
          videoTitleBottomFromSidebar - recommendationsTitleBottomFromSection;

        // Get current margin-top to check if it needs to be updated
        const currentMarginTop = parseInt(
          recommendationsSection.style.marginTop || "0"
        );

        // Calculate new margin-top
        const marginTop = Math.max(
          0,
          sectionTop - stepNavHeight - stepNavMarginBottom
        );

        // Only update if the value actually changed (prevents infinite loop)
        if (Math.abs(currentMarginTop - marginTop) > 1) {
          // Temporarily disconnect observer to prevent triggering it
          if (this.mutationObserver) {
            this.mutationObserver.disconnect();
          }

          // Reset any previous positioning
          recommendationsSection.style.removeProperty("position");
          recommendationsSection.style.removeProperty("top");
          recommendationsSection.style.removeProperty("left");
          recommendationsSection.style.removeProperty("right");
          recommendationsSection.style.removeProperty("width");

          // Set margin-top to position the section so its h2 bottom aligns with the video title bottom
          // Account for the step-navigation height and margin
          recommendationsSection.style.setProperty(
            "margin-top",
            `${marginTop}px`,
            "important"
          );
          recommendationsSection.style.setProperty(
            "padding-top",
            "0",
            "important"
          );

          // Reconnect observer after a short delay
          setTimeout(() => {
            if (this.mutationObserver) {
              const mainContent = document.querySelector(".flow-main-content");
              if (mainContent) {
                this.mutationObserver.observe(mainContent, {
                  attributes: true,
                  attributeFilter: ["class"],
                });
              }
            }
            this.isAligning = false;
          }, 100);
        } else {
          this.isAligning = false;
        }
      } else {
        this.isAligning = false;
      }
    } else {
      this.isAligning = false;
    }
  }

  onResize(event) {
    this.resize(event);
  }

  purchaseFlow() {
    if (this.tempFlows.length <= 0) {
      if (
        this.flowData.price != null &&
        this.flowData.isPaid &&
        this.userData == null
      ) {
        localStorage.setItem("checkoutFlow", JSON.stringify(this.flowData));
        // this.router.navigate(['/login'], {
        //   queryParams: { returnUrl: this.router.url }
        // });
 this.authModalService.openModal('registration', this.router.url);
      } else if (
        this.flowData.price != null &&
        this.flowData.isPaid &&
        !this.flowData.isFlowPurchased &&
        this.userData.emailAddress != this.flowData.customerEmail
      ) {
        if (this.userData != null) {
          localStorage.setItem("checkoutFlow", JSON.stringify(this.flowData));
          this.router.navigate(["/checkout"]);
        } else {
          //   this.router.navigate(['/login'], {
          //   queryParams: { returnUrl: this.router.url }
          // });
 this.authModalService.openModal('registration', this.router.url);
        }
      }
    } else {
      this.checkoutconfirmpopup();
    }
  }

  private applyStoredUserProfilePicture(): void {
    if (!this.userData) {
      return;
    }
    const pic =
      this.userData.profilePicUrl || this.userData.ProfilePicUrl || "";
    if (pic) {
      this.showDefaultImage = false;
      this.profilePicture = pic;
    } else {
      this.showDefaultImage = true;
      this.profilePicture = null;
    }
  }

  private updateFlowAccessFromStoredUser(): void {
    if (!this.flowData) {
      return;
    }
    if (this.userData != null) {
      this.showNotificationCount = true;
      if (this.userData.emailAddress === this.flowData.customerEmail) {
        this.showMenu = true;
        this.isPurchaseRequired = false;
        this.notFlowOwner = false;
      } else {
        this.showMenu = false;
        this.isPurchaseRequired =
          !this.flowData.isFlowPurchased && this.flowData.isPaid;
        this.notFlowOwner = true;
      }
      return;
    }
    this.isPurchaseRequired =
      !this.flowData.isFlowPurchased && this.flowData.isPaid;
    this.notFlowOwner = true;
  }

  getProfileUser(): void {
    if (this.userData != null) {
      this.showNotificationCount = true;
      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
          this.profilePicture = null;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
          this.userData.profilePicUrl = data.userData.profilePicUrl;
          localStorage.setItem(
            "LoggedInUser",
            JSON.stringify(this.userData)
          );
        }

        this.email = data.userData.emailAddress;
        this.phone = data.userData.PhoneNumber;
        this.info = data.userData.Info;
        this.website = data.userData.Website;
        this.userDisplayName = data.userData.UserName;
        this.name = data.userData.FirstName;
        this.updateFlowAccessFromStoredUser();
        this.cdr.markForCheck();
      });
    } else {
      this.updateFlowAccessFromStoredUser();
    }
  }

  checkLoggedIn() {
    if (this.userData === null) {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
 this.authModalService.openModal('registration', this.router.url);
    } else {
      this.flowNavigationService.captureReturnPath();
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
 this.authModalService.openModal('registration', this.router.url);
    }
  }

  moveOnCoverPage() {
    this.stepNumber = 0;
    this.stepCount = 0;
    this.nextCount = 0;

    this.imageSource = this.flowData?.url;
    this.description = this.flowData.description;
    this.posterImageSource = this.flowData.videoThumbNailUrl;
    this.isFirstSlide = true;
    this.isFlowHomePage = true;

    // In preview dialog, render cover as image to avoid black video frame states.
    if (this.openInDialog) {
      const coverUrl = this.flowData?.url || this.flowData?.Url || "";
      const coverPoster =
        this.flowData?.videoThumbNailUrl ||
        this.flowData?.VideoThumbNailUrl ||
        "";
      if (coverUrl && this.isVideoUrl(coverUrl) && coverPoster) {
        this.imageSource = coverPoster;
      } else {
        this.imageSource = coverUrl || coverPoster || this.imageSource;
      }
      this.showVideoOrImage = false;
      return;
    }

    if (this.flowData?.url) {
      this.showVideoFromFile(this.flowData.url);
    } else {
      this.showVideoOrImage = false;
    }
  }

  goToQrCode(flowData) {
    // localStorage.setItem("flow", JSON.stringify(flowData));
    // this.router.navigate(["/qrcode"]);
    localStorage.setItem("flow", JSON.stringify(flowData));
    const dialogRef = this.dialog.open(QRCodeComponent, {
      panelClass: "dialoguebox",
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  isSeparator(value: string) {
    if (value === "/" || value === "\\" || value === ":") return true;
  }

  getExtension = (path: string | null | undefined): string => {
    if (!path) {
      return "";
    }
    const sanitizedPath = path.split("?")[0].split("#")[0];

    for (let i = sanitizedPath.length - 1; i > -1; --i) {
      const value = sanitizedPath[i];
      if (value === ".") {
        if (i > 1) {
          if (this.isSeparator(sanitizedPath[i - 1])) {
            return "";
          }
          return sanitizedPath.substring(i + 1).toLowerCase();
        }
        return "";
      }
      if (this.isSeparator(value)) {
        return "";
      }
    }
    return "";
  };

  CheckUserLoggedIn() {
    if (
      this.userData == null &&
      this.flowData.price != null &&
      this.flowData.isPaid
    ) {
      localStorage.setItem("checkoutFlow", JSON.stringify(this.flowData));
      localStorage.setItem("returnUrl", this.router.url);
       this.authModalService.openModal('registration', this.router.url);
    } else if (
      this.userData != null &&
      !this.flowData.isFlowPurchased &&
      this.flowData.price != null &&
      this.flowData.isPaid &&
      this.userData.emailAddress !== this.flowData.customerEmail
    ) {
      localStorage.setItem("checkoutFlow", JSON.stringify(this.flowData));
      this.router.navigate(["/checkout"]);
    }
  }
  NextStep() {
    if (this.gateOnStepQuestions(() => this.NextStep())) return;

    // Stop autoplay for current step before moving
    this.stopAutoplay();
    
    // Clear any existing toast messages when step changes
    if (this.isMobileView) {
      this.toastr.clear();
    }

    // If the flow was fully completed (100%) before this navigation,
    // reset progress so a fresh run can start when using Next.
    if (this.getCompletionPercentage() === 100) {
      this.visitedSteps = new Set();
      this.hasRestartedAfterCompletion = true;
    }

    this.imageSource = null;
    this.description = null;
    this.selectedStepIndex = this.selectedStepIndex + 1;
    this.itemsRequired = 0;
    this.coverPage = false;
    this.isFlowHomePage = false;
    this.stepNumber = 0;
    this.nextCount = 0;
    this.stepCount = 0;
    this.isFirstSlide = false;
    this.scrollToStep();
    if (this.selectedStepIndex === -2) {
      this.setCoverPage();
    } else if (this.selectedStepIndex === -1) {
      if (this.flowData.components.length <= 0) {
        this.selectedStepIndex = this.selectedStepIndex + 1;
        this.setStep(this.selectedStepIndex);
        if (this.selectedStepIndex + 1 === this.flowData.steps.length) {
          this.isLastSlide = true;
        }
      } else {
        this.setItemsPage();
      }
    } else {
      this.setStep(this.selectedStepIndex);
      if (this.selectedStepIndex + 1 === this.flowData.steps.length) {
        this.isLastSlide = true;
      }
      // console.log(this.isLastSlide);
      // console.log(this.selectedStepIndex + 1);
      // console.log(this.flowData.steps.length);
    }

    this.updateUrlFragment();
  }
  PreviousStep() {
    // Stop autoplay for current step before moving
    this.stopAutoplay();
    
    // Clear any existing toast messages when step changes
    if (this.isMobileView) {
      this.toastr.clear();
    }

    // If the flow was fully completed (100%) before this navigation,
    // reset progress so a fresh run can start when using Previous.
    if (this.getCompletionPercentage() === 100) {
      this.visitedSteps = new Set();
      this.hasRestartedAfterCompletion = true;
    }

    this.imageSource = null;
    this.description = null;
    this.selectedStepIndex = this.selectedStepIndex - 1;
    this.itemsRequired = 0;
    this.coverPage = false;
    this.isFlowHomePage = false;
    this.stepNumber = 0;
    this.nextCount = 0;
    this.stepCount = 0;
    this.isFirstSlide = false;
    this.isLastSlide = false;
    this.scrollToStep();
    if (this.selectedStepIndex === -2) {
      this.setCoverPage();
      this.isFirstSlide = true;
    } else if (this.selectedStepIndex === -1) {
      if (this.flowData.components.length <= 0) {
        this.selectedStepIndex = this.selectedStepIndex - 1;
        this.setCoverPage();
        this.isFirstSlide = true;
      } else {
        this.setItemsPage();
      }
    } else {
      this.setStep(this.selectedStepIndex);
    }
    this.updateUrlFragment();
  }
  updateUrlFragment() {
    console.log(this.selectedStepIndex);
    let stepId = "";
    if (this.selectedStepIndex === -2) {
      stepId = "";
    } else if (this.selectedStepIndex === -1) {
      stepId = "itemsRequired";
    } else if (this.selectedStepIndex >= this.flowData.steps.length) {
      stepId = "";
      this.selectedStepIndex = -2;
      this.setCoverPage();
    } else if (this.selectedStepIndex >= 0) {
      stepId = `step${this.selectedStepIndex + 1}`;
    }

    console.log(this.selectedStepIndex);
    console.log("step" + stepId);
    console.log(
      "condition" + this.selectedStepIndex >= this.flowData.steps.length
    );
    const baseUrl = window.location.href.split("#")[0]; // Remove existing hash if any
    const newUrl =
      this.selectedStepIndex == -2 ||
      this.selectedStepIndex >= this.flowData.steps.length
        ? `${baseUrl}`
        : `${baseUrl}#${stepId}`;
    history.replaceState(null, "", newUrl);
  }

  copyCurrentLinkToClipboard() {
    const currentUrl = window.location.href;
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        this.toastr.success("Link copied to clipboard!");
      })
      .catch(() => {
        this.toastr.error("Failed to copy link.");
      });
  }

  setStepData(index) {
    this.selectedStepIndex = index;
    var path = this.getExtension(this.flowData.steps[index].url);

    const imageExtensions = [
      "jpeg",
      "jpg",
      "png",
      "gif",
      "jfif",
      "tiff",
      "tif",
      "pdf",
      "bmp",
      "webp",
      "svg",
      "heic",
      "heif",
      "raw",
      "arw",
      "cr2",
      "nef",
      "orf",
      "rw2",
      "dng",
      "psd",
      "ico",
      "exif",
      "pjpeg",
      "ppm",
      "pgm",
      "pbm",
      "pnm",
      "xpm",
      "tga",
      "pcx",
      "jp2",
      "jpx",
      "eps",
      "ai",
    ];
    const videoExtensions = [
      "mp4",
      "mov",
      "wmv",
      "flv",
      "avchd",
      "webm",
      "mkv",
      "vob",
      "ogv",
      "gifv",
      "m4p",
      "m4v",
      "3gp",
      "3g2",
      "amv",
      "nsv",
      "ogg",
      "f4v",
      "f4p",
      "f4a",
      "f4b",
      "avi",
      "mts",
      "m2ts",
      "ts",
      "mpg",
      "mpeg",
      "rm",
      "rmvb",
      "divx",
      "xvid",
      "asf",
      "mxf",
      "dv",
      "h264",
      "h265",
      "vp8",
      "vp9",
      "prores",
      "swf",
      "dat",
      "bik",
      "av1",
      "vro",
      "svi",
    ];

    const lowerUrl = path.toLowerCase();

    if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showVideoOrImage = true;
    } else if (videoExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showVideoOrImage = false;
    }
  }
  selectStepAdvanced(index: number) {
    if (this.isEmbedNavigationLocked && !this.isApplyingEmbedView) {
      return;
    }
    if (this.gateForwardNavigation(index, () => this.selectStepAdvanced(index))) return;

    // Stop autoplay for current step before moving
    this.stopAutoplay();
    
    // Clear any existing toast messages when step changes
    if (this.isMobileView) {
      this.toastr.clear();
    }

    // For actual steps (index >= 0), detect revisits and (optionally) reset progress.
    if (this.flowData && this.flowData.steps && index >= 0 && index < this.flowData.steps.length) {
      // If this step was already visited, treat this as a "revisit" so the
      // progress bar track can switch to the blue #e3f2fd color.
      if (this.visitedSteps.has(index)) {
        this.hasRestartedAfterCompletion = true;
      }

      // If the flow was fully completed (100%) before this navigation,
      // reset progress so they can start a fresh run.
      if (this.getCompletionPercentage() === 100) {
        this.visitedSteps = new Set();
      }
    }

    this.selectedStepIndex = index;
    this.itemsRequired = 0;
    this.coverPage = false;
    this.isFlowHomePage = false;
    this.stepNumber = 0;
    this.nextCount = 0;
    this.stepCount = 0;
    this.isLastSlide = false;
    if (index === -2) {
      this.setCoverPage();
    } else if (index === -1) {
      this.setItemsPage();
    } else {
      this.setStep(index);
    }
    this.scrollToStep();
    this.updateUrlFragment();
  }
  private setCoverPage() {
    this.isFlowHomePage = this.coverPage = true;
    this.imageSource = this.flowData.url;
    this.description = this.flowData.description;
    this.posterImageSource = this.flowData.videoThumbNailUrl;
    this.isFirstSlide = true;
    this.showVideoFromFile(this.flowData.url);

    // Start autoplay if enabled
    this.startAutoplayForCurrentStep();
  }

  private setItemsPage() {
    this.CheckUserLoggedIn();
    this.description = this.stepText;
    this.itemsRequired = 1;
    this.nextCount = 1;
    this.stepCount = 0;
    this.isFirstSlide = false;

    Object.keys(this.groupedData).forEach((groupKey) => {
      this.expandedGroups[groupKey] = true;
    });

    // Start autoplay if enabled (wait 4 seconds for items page)
    this.startAutoplayForCurrentStep();
  }

  private setStep(index: number) {
    this.isFirstSlide = false;
    if (this.selectedStepIndex + 1 === this.flowData.steps.length) {
      this.isLastSlide = true;
    }
    this.CheckUserLoggedIn();
    const step = this.flowData.steps[index];
    console.log(`Step ${this.stepNumber} selected`, step);
    if (!step) return; // Prevent potential errors
    
    // Track step visit
    this.trackStepVisit(index);
    
    if (this.isToggled) {
      this.setStepData(index);
    } else {
      this.imageSource = step.url;
      this.description = step.description;
      // Map TaggedItems (from API) to taggedItems (for component)
      // Handle both TaggedItems (capital T) and taggedItems (lowercase t) for compatibility
      this.currentStepTaggedItems = step.TaggedItems || step.taggedItems || []; // Load tagged items for current step
      this.showVideoFromFile(this.imageSource);
      localStorage.setItem("imageSource", JSON.stringify(this.imageSource));
      this.stepNumber = index + 1;
      this.stepCount = index + 1;
      this.nextCount = index + 1;
      console.log(`Step ${this.stepNumber} selected`);

      // Start autoplay if enabled
      this.startAutoplayForCurrentStep();
    }
  }

  openItemDetailsDialog(item: any) {
    // Open dialog to show item details
    this.dialog.open(ItemDetailsDialogComponent, {
      width: '600px',
      maxWidth: '90vw',
      panelClass: 'item-details-dialog-panel',
      data: {
        itemName: item.itemName || item.itemkey || item.itemKey || '',
        itemQuantity: item.itemValue || item.quantity || '',
        itemGroupName: item.groupName || '',
        itemWhereToFindIt: item.wheretofindit || item.link || '',
        imageUrl: item.url || item.imageUrl || '',
        itemGroupList: [],
        readOnly: true // Make it read-only for viewing
      }
    });
  }

  // Check if current user is the flow owner
  isFlowOwner(): boolean {
    if (!this.userData || !this.flowData) {
      return false;
    }
    const owner = String(this.flowData.customerEmail || this.flowData.CustomerEmail || "").trim().toLowerCase();
    const viewer = String(this.userData.emailAddress || "").trim().toLowerCase();
    return !!owner && owner === viewer;
  }

  // Check if current step/cover is safety critical
  isCurrentStepSafetyCritical(): boolean {
    // Check cover safety first (when viewing cover)
    if (this.selectedStepIndex === -2) {
      return this.flowData?.CoverIsSafetyCritical === true || this.flowData?.coverIsSafetyCritical === true;
    }
    
    // Check for actual steps (not cover page or items page)
    if (this.selectedStepIndex < 0 || !this.flowData?.steps) {
      return false;
    }
    
    const currentStep = this.flowData.steps[this.selectedStepIndex];
    if (!currentStep) {
      return false;
    }
    
    // Check both IsSafetyCritical (from API) and isSafetyCritical (normalized)
    return currentStep.IsSafetyCritical === true || currentStep.isSafetyCritical === true;
  }

  // Get safety tooltip text for current step/cover
  getCurrentStepSafetyTooltip(): string {
    if (!this.isCurrentStepSafetyCritical()) {
      return '';
    }
    
    // Check cover safety first
    if (this.selectedStepIndex === -2) {
      const coverTitle = this.flowData?.CoverSafetyInstructionsTitle || this.flowData?.coverSafetyInstructionsTitle;
      if (coverTitle) {
        return coverTitle;
      }
      return 'This is a safety critical cover. Please follow all safety instructions carefully.';
    }
    
    const currentStep = this.flowData.steps[this.selectedStepIndex];
    // First check for safety instructions title
    if (currentStep?.safetyInstructionsTitle || currentStep?.SafetyInstructionsTitle) {
      return currentStep.safetyInstructionsTitle || currentStep.SafetyInstructionsTitle;
    }
    // Fall back to default message from viewflow
    return 'This is a safety critical step. Please follow all safety instructions carefully.';
  }

  // Check if cover is safety critical
  isCoverSafetyCritical(): boolean {
    return this.flowData?.CoverIsSafetyCritical === true || this.flowData?.coverIsSafetyCritical === true;
  }

  // Get cover safety instructions
  getCoverSafetyInstructions(): any {
    if (!this.isCoverSafetyCritical()) {
      return null;
    }
    return {
      title: this.flowData?.CoverSafetyInstructionsTitle || this.flowData?.coverSafetyInstructionsTitle || 'Safety Instructions',
      description: this.flowData?.CoverSafetyInstructionsDescription || this.flowData?.coverSafetyInstructionsDescription || ''
    };
  }

  // Get current step/cover safety instructions for sidebar
  getCurrentSafetyInstructions(): any {
    if (this.selectedStepIndex === -2) {
      return this.getCoverSafetyInstructions();
    }
    
    if (this.selectedStepIndex < 0 || !this.flowData?.steps) {
      return null;
    }
    
    const currentStep = this.flowData.steps[this.selectedStepIndex];
    if (!currentStep || (!currentStep.IsSafetyCritical && !currentStep.isSafetyCritical)) {
      return null;
    }
    
    return {
      title: currentStep?.SafetyInstructionsTitle || currentStep?.safetyInstructionsTitle || 'Safety Instructions',
      description: currentStep?.SafetyInstructionsDescription || currentStep?.safetyInstructionsDescription || ''
    };
  }

  // Get current step/cover tagged items
  getCurrentTaggedItems(): any[] {
    if (this.selectedStepIndex === -2) {
      return []; // Cover doesn't have tagged items
    }
    
    if (this.selectedStepIndex < 0 || !this.flowData?.steps) {
      return [];
    }
    
    const currentStep = this.flowData.steps[this.selectedStepIndex];
    return currentStep?.TaggedItems || currentStep?.taggedItems || [];
  }

  // Edit tagged item
  editTaggedItem(item: any, stepIndex: number, itemIndex: number, event?: Event) {
    if (event) {
      event.stopPropagation(); // Prevent chip click event
    }
    
    if (!this.isFlowOwner()) {
      this.toastr.warning('Only the flow owner can edit tagged items');
      return;
    }

    // If stepIndex is -1 or invalid, try to find it from currentStepTaggedItems
    if (stepIndex < 0 && this.selectedStepIndex >= 0) {
      stepIndex = this.selectedStepIndex;
    }

    // Get item group list from components if available
    const itemGroupList = this.flowData.components && Array.isArray(this.flowData.components)
      ? [...new Set(this.flowData.components.map(comp => comp.groupName).filter(Boolean))]
      : [];

    const dialogRef = this.dialog.open(ItemDetailsDialogComponent, {
      width: '600px',
      maxWidth: '90vw',
      panelClass: 'item-details-dialog-panel',
      data: {
        itemName: item.itemName || item.itemkey || item.itemKey || '',
        itemQuantity: item.itemValue || item.quantity || '',
        itemGroupName: item.groupName || '',
        itemWhereToFindIt: item.wheretofindit || item.link || '',
        imageUrl: item.url || item.imageUrl || '',
        itemGroupList: itemGroupList,
        readOnly: false // Enable editing
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Update the item with edited values
        const updatedItem = {
          ...item,
          itemName: result.itemName || '',
          itemkey: result.itemName || '',
          itemKey: result.itemName || '',
          itemValue: result.itemQuantity || '',
          quantity: result.itemQuantity || '',
          groupName: result.itemGroupName || '',
          link: result.itemWhereToFindIt || '',
          wheretofindit: result.itemWhereToFindIt || ''
        };

        // Remove empty properties
        Object.keys(updatedItem).forEach(key => {
          if (updatedItem[key] === '' || updatedItem[key] === null || updatedItem[key] === undefined) {
            delete updatedItem[key];
          }
        });

        // Update in flowData.steps
        if (this.flowData.steps && stepIndex >= 0 && this.flowData.steps[stepIndex]) {
          const step = this.flowData.steps[stepIndex];
          const taggedItems = step.TaggedItems || step.taggedItems || [];
          if (taggedItems[itemIndex] !== undefined) {
            taggedItems[itemIndex] = updatedItem;
            step.taggedItems = taggedItems;
            step.TaggedItems = taggedItems; // Keep both for compatibility
          }
        }

        // Update in dataSourceSteps
        if (this.dataSourceSteps && stepIndex >= 0 && this.dataSourceSteps[stepIndex]) {
          const step = this.dataSourceSteps[stepIndex];
          if (step.taggedItems && step.taggedItems[itemIndex] !== undefined) {
            step.taggedItems[itemIndex] = updatedItem;
          }
        }

        // Update currentStepTaggedItems if this is the current step
        if (this.selectedStepIndex === stepIndex || (stepIndex < 0 && this.selectedStepIndex >= 0)) {
          const currentItems = this.currentStepTaggedItems;
          if (currentItems && currentItems[itemIndex] !== undefined) {
            currentItems[itemIndex] = updatedItem;
          }
        }

        // Sync edit back into flowData.components so the itemsRequired table reflects the change
        if (this.flowData.components && this.flowData.components.length > 0) {
          const compIndex = this.flowData.components.findIndex(comp =>
            (item.rowKey && comp.rowKey === item.rowKey) ||
            (item.itemkey && comp.itemkey === item.itemkey) ||
            (item.itemKey && comp.itemKey === item.itemKey) ||
            (item.itemName && comp.itemName === item.itemName)
          );
          if (compIndex !== -1) {
            this.flowData.components[compIndex] = {
              ...this.flowData.components[compIndex],
              ...updatedItem
            };
          }
        }

        // Rebuild dataSource and groupedData so itemsRequired table re-renders
        this.dataSource = [...(this.flowData.components || [])];
        this.groupDataByGroupName();
        this.cdr.markForCheck();

        // Persist only this one tagged item to the server (lightweight — no full flow re-save)
        if (stepIndex >= 0) {
          this.saveStepToServer(stepIndex, itemIndex, updatedItem);
        }

        this.toastr.success('Tagged item updated successfully');
      }
    });
  }

  // Save a single tagged item edit to the server without re-saving the whole flow
  saveStepToServer(stepIndex: number, itemIndex?: number, updatedItem?: any) {
    if (!this.flowData?.steps?.[stepIndex]) {
      return;
    }

    const step = this.flowData.steps[stepIndex];
    const stepRowKey = step.rowKey || step.RowKey;

    if (!stepRowKey) {
      console.warn('saveStepToServer: step has no rowKey, cannot persist.');
      return;
    }

    // itemIndex / updatedItem are optional — when supplied use the lightweight endpoint;
    // fall back to a no-op otherwise (a full re-save is intentionally removed).
    if (itemIndex === undefined || updatedItem === undefined) {
      return;
    }

    const payload = {
      flowId: this.flowData.rowKey || this.flowData.RowKey || '',
      stepRowKey,
      itemIndex,
      updatedItem
    };

    this.flowServiceService.updateTaggedItem(payload).subscribe({
      next: () => {},
      error: (err) => {
        console.error('Failed to save tagged item to server:', err);
        this.toastr.error('Could not save item update to server.');
      }
    });
  }

  onToggleChange(event: any) {
    this.isToggled = event.checked;
    this.selectStepAdvanced(
      this.selectedStepIndex !== -2 ? this.selectedStepIndex : -2
    );
  }

  showVideoFromFile(filePath: string | null | undefined) {
    const extension = this.getExtension(filePath);
    if (!filePath || !extension) {
      this.showVideoOrImage = false;
      this.imageSource = filePath || null;
      return;
    }
    this.showVideoOrImage = this.videoFileExtensions.includes(extension);
    this.imageSource = filePath;
  }

  onPrimaryVideoError(): void {
    // If media URL is not actually a playable video, fallback to image renderer.
    this.showVideoOrImage = false;
    this.imageSource =
      this.posterImageSource ||
      this.flowData?.url ||
      this.flowData?.Url ||
      this.imageSource;
  }

  onPrimaryImageError(): void {
    const fallback =
      this.posterImageSource ||
      this.flowData?.videoThumbNailUrl ||
      this.flowData?.VideoThumbNailUrl ||
      "assets/images/blank.png";
    this.showVideoOrImage = false;
    this.imageSource = fallback;
  }

  isFlowViewed() {
    if (this.flowData != null && this.hasFlowRowKey(this.flowData.rowKey)) {
      //this.noResultReturned = true;
      //
      const flowModel = {
        FlowId: this.flowData.rowKey,
      };

      this.flowServiceService.getIsFlowViewed(flowModel).subscribe((data) => {
        this.viewsCount = data.viewsCount;
        if (this.viewsCount > 1) {
          this.viewText = "Views";
        } else this.viewText = "View";
        //this.noResultReturned = false;
        //
        this.CheckIsUserFollowing();
      });
    }
  }

  isFlowLiked() {
    if (this.userData != null) {
      //
      //this.noResultReturned = true;
      const flowModel = {
        FlowId: this.flowData.rowKey,
        LikedByUserEmail: this.userData.emailAddress,
      };

      this.flowServiceService.isFlowLiked(flowModel).subscribe((data) => {
        //this.noResultReturned = false;
        if (data.IsLiked === "liked") {
          this.likecolor = true;
        } else if (data.IsLiked === "unliked") {
          this.likecolor = false;
        }

        //
        this.CheckIsUserFollowing();
      });
    }
  }

  viewUserProfile(selectedFlow) {
    if (this.userData != null) {
      if (this.userData.emailAddress === selectedFlow.customerEmail) {
        this.router.navigate(["/user-profile"]);
      } else if (selectedFlow.userName) {
        this.router.navigate(["/view-profile", selectedFlow.userName.replace(/^@/, '')]);
      } else {
        this.dataService.flowByCategorieschangeMessage(selectedFlow);
        this.router.navigate(["/view-profile"]);
      }
    } else {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
 this.authModalService.openModal('registration', this.router.url);
    }
  }

  viewOwnerProfileFromRec(item: any, event: Event): void {
    event.stopPropagation();
    this.viewUserProfile(item);
  }

  viewCoAuthorProfile(item: any, event: Event): void {
    event.stopPropagation();
    if (!item.coAuthorEmail) return;
    if (this.userData?.emailAddress === item.coAuthorEmail) {
      this.router.navigate(['/user-profile']);
    } else if (item.coAuthorUserName) {
      this.router.navigate(['/view-profile', item.coAuthorUserName.replace(/^@/, '')]);
    } else {
      this.dataService.flowByCategorieschangeMessage({ customerEmail: item.coAuthorEmail });
      this.router.navigate(['/view-profile']);
    }
  }

  /** Item whose collaborators popup is currently open (null = closed). */
  collabPopupItem: any = null;
  collabPopupCoAuthors: { email: string; userName: string; profilePicUrl: string }[] = [];

  showCollabPopup(item: any, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = this.collabPopupItem === item ? null : item;
    this.collabPopupCoAuthors = this.collabPopupItem ? this.getCollabCoAuthors(this.collabPopupItem) : [];
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.collabPopupItem = null;
    this.collabPopupCoAuthors = [];
  }

  navigateToUserFromPopup(item: any, isCoAuthor: boolean, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = null;
    this.collabPopupCoAuthors = [];
    if (isCoAuthor) {
      this.viewCoAuthorProfile(item, event);
    } else {
      this.viewUserProfile(item);
    }
  }

  isCollabFlow(item: any): boolean {
    if (!(item?.isCollaboration || item?.IsCollaboration)) return false;
    if (!(item?.coAuthorEmail || item?.CoAuthorEmail)) return false;
    // Check per-person statuses first (array wins over single status)
    const statusesRaw = item?.coAuthorStatuses || item?.CoAuthorStatuses || null;
    if (statusesRaw) {
      try {
        const statuses: string[] = JSON.parse(statusesRaw);
        return statuses.some(s => s === 'Accepted');
      } catch {}
    }
    // Fall back to single collaborationStatus field
    const status = item?.collaborationStatus || item?.CollaborationStatus || '';
    return status === 'Accepted';
  }

  /** Returns the first accepted co-author's username for the "and @username" text. */
  coAuthorDisplay(item: any): string {
    const accepted = this.getCollabCoAuthors(item);
    return accepted.length > 0 ? accepted[0].userName : '';
  }

  getCollabCoAuthors(item: any): { email: string; userName: string; profilePicUrl: string }[] {
    if (!item) return [];
    const coAuthorEmail     = item.coAuthorEmail    || item.CoAuthorEmail    || null;
    const coAuthorUserName  = item.coAuthorUserName || item.CoAuthorUserName || null;
    const coAuthorPicUrl    = item.coAuthorProfilePicUrl || item.CoAuthorProfilePicUrl || null;
    const coAuthorEmails    = item.coAuthorEmails    || item.CoAuthorEmails    || null;
    const coAuthorUserNames = item.coAuthorUserNames || item.CoAuthorUserNames || null;
    const coAuthorPicUrls   = item.coAuthorProfilePicUrls || item.CoAuthorProfilePicUrls || null;
    const coAuthorStatuses  = item.coAuthorStatuses  || item.CoAuthorStatuses  || null;
    let emails: string[] = [];
    let userNames: string[] = [];
    let profilePicUrls: string[] = [];
    let statuses: string[] = [];
    try { if (coAuthorEmails) emails = JSON.parse(coAuthorEmails); } catch {}
    try { if (coAuthorUserNames) userNames = JSON.parse(coAuthorUserNames); } catch {}
    try { if (coAuthorPicUrls) profilePicUrls = JSON.parse(coAuthorPicUrls); } catch {}
    try { if (coAuthorStatuses) statuses = JSON.parse(coAuthorStatuses); } catch {}
    const singleStatus = item?.collaborationStatus || item?.CollaborationStatus || '';
    if (Array.isArray(emails) && emails.length > 0) {
      return emails
        .map((email, i) => ({
          email,
          userName: userNames[i] || (i === 0 ? coAuthorUserName : '') || email,
          profilePicUrl: profilePicUrls[i] || (i === 0 ? coAuthorPicUrl : '') || '',
          status: statuses[i] || singleStatus,
        }))
        .filter(c => c.status === 'Accepted');
    }
    if (coAuthorEmail && singleStatus === 'Accepted') {
      return [{ email: coAuthorEmail, userName: coAuthorUserName || coAuthorEmail, profilePicUrl: coAuthorPicUrl || '' }];
    }
    return [];
  }

  getExtraCollabCount(item: any): number {
    return Math.max(0, this.getCollabCoAuthors(item).length - 1);
  }

  navigateToCoAuthorProfile(coAuthor: { email: string; userName: string; profilePicUrl: string }, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = null;
    this.collabPopupCoAuthors = [];
    const syntheticItem = { coAuthorEmail: coAuthor.email, coAuthorUserName: coAuthor.userName };
    this.viewCoAuthorProfile(syntheticItem, event);
  }

  likeFlow() {
    if (this.userData != null) {
      const previousLikeState = !!this.likecolor;
      const optimisticLikeState = !previousLikeState;

      // Optimistic UI update only for icon state.
      this.likecolor = optimisticLikeState;
      this.cdr.detectChanges();

      const flowModel = {
        PartitionKey: this.flowData.rowKey,
        LikedByUserEmail: this.userData.emailAddress,
      };

      this.flowServiceService.LikeFlow(flowModel).subscribe(
        (data) => {
          //this.noResultReturned = false;
          console.log("liked", this.flowData);
          const apiTotalLikes =
            typeof data?.totalLikes === "number"
              ? data.totalLikes
              : typeof data?.TotalLikes === "number"
              ? data.TotalLikes
              : NaN;
          const totalLikes = !isNaN(apiTotalLikes)
            ? Math.max(apiTotalLikes, 0)
            : 0;
          this.flowData.likedFlowCount = totalLikes;
          if (data.liked === "liked") {
            this.likecolor = true;
            this.showToast();
          } else if (data.liked === "unliked") {
            this.likecolor = false;
            this.showToastForUnlike();
          }
          this.flowData.likeCount = totalLikes;
          this.viewsCount = data.viewsCount;

          if (this.viewsCount > 1) {
            this.viewText = "Views";
          } else {
            this.viewText = "View";
          }
          this.cdr.detectChanges();
          //
        },
        () => {
          // Roll back optimistic icon state if API call fails.
          this.likecolor = previousLikeState;
          this.cdr.detectChanges();
        }
      );
    } else {
      // this.router.navigate(['/registration'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
       this.authModalService.openModal('registration', this.router.url);
    }
  }

  CheckIsUserFollowing() {
    const loggedInEmail = (this.userData?.emailAddress || this.userData?.partitionKey || "").toString().trim();
    const ownerEmail = (
      this.flowData?.customerEmail ||
      this.flowData?.partitionKey ||
      this.flowData?.emailAddress
    ).toString().trim();
    if (this.userData != null) {
      if (
        loggedInEmail &&
        ownerEmail &&
        loggedInEmail.toLowerCase() === ownerEmail.toLowerCase()
      ) {
        this.showFollow = false;
      } else {
        this.showFollow = true;

        const flowModel = {
          UserEmail: ownerEmail,
          FollowerEmail: loggedInEmail,
        };

        this.flowServiceService
          .CheckIsUserFollowing(flowModel)
          .pipe(
            catchError((error) => {
              // Handle error gracefully - set default follow button state
              console.error("Error checking user following status:", error);
              this.followButtonText = "Follow";
              this.followingcolor = "white";
              this.followingbgcolor = "#5ea1d8";
              // Return a safe default observable to prevent error propagation
              return of({ messageText: "NotFollowing" });
            })
          )
          .subscribe({
            next: (data) => {
              const status = (data?.MessageText || data?.messageText || "").toString();
              if (status === "Following") {
                this.followButtonText = "Following";
                this.followingcolor = "#5ea1d8";
                this.followingbgcolor = "white";
              } else {
                this.followButtonText = "Follow";
                this.followingcolor = "white";
                this.followingbgcolor = "#5ea1d8";
              }
            }
          });
      }
    } else {
      // Not logged in: still show Follow button
      this.showFollow = true;
      this.followButtonText = "Follow";
      this.followingcolor = "white";
      this.followingbgcolor = "#5ea1d8";
    }
  }

  followUser() {
    if (this.userData != null) {
      if (this.isFollowLoading) {
        return;
      }
      this.isFollowLoading = true;
      const ownerEmail = (
        this.flowData?.customerEmail ||
        this.flowData?.partitionKey ||
        this.flowData?.emailAddress
      ).toString().trim();
      if (!ownerEmail) {
        this.isFollowLoading = false;
        this.toastr.info("Profile is unavailable.");
        return;
      }
      //
      //this.noResultReturned = true;
      const flowModel = {
        FollowerEmail: (this.userData?.emailAddress || this.userData?.partitionKey || "").toString().trim(),
        UserEmail: ownerEmail,
      };

      this.flowServiceService.FollowUser(flowModel).subscribe({
        next: (data) => {
          const nextStatus = (data?.isFollowing || data?.IsFollowing || "").toString().trim().toLowerCase();
          if (nextStatus === "following") {
            this.followButtonText = "Following";
            this.followingcolor = "#5ea1d8";
            this.followingbgcolor = "white";
          } else {
            this.followButtonText = "Follow";
            this.followingcolor = "white";
            this.followingbgcolor = "#5ea1d8";
          }
          // this.noResultReturned = false;
          //
          this.isFollowLoading = false;
          this.cdr.detectChanges();
          this.CheckIsUserFollowing();
        },
        error: (error) => {
          console.error("Error following user:", error);
          this.isFollowLoading = false;
          this.cdr.detectChanges();
          // Optionally show a toast notification or handle the error
        }
      });
    } else {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      this.authModalService.openModal('registration', this.router.url);
    }
  }

  isFlowSaved() {
    if (this.userData != null) {
      //
      const flowModel = {
        CustomerEmail: this.userData.emailAddress,
        FlowId: this.flowData.rowKey,
      };

      this.flowServiceService
        .getFlowBookMarkedStatus(flowModel)
        .subscribe({
          next: (data) => {
            if (data.IsSaved === true) {
              this.bookmarkcolor = "black";
            } else {
              this.bookmarkcolor = "gray";
            }
            //this.noResultReturned = false;
            //
          },
          error: (error) => {
            console.error("Error checking flow bookmark status:", error);
            // Set default bookmark color on error
            this.bookmarkcolor = "gray";
          }
        });
    }
  }

  shareFlow() {}
  showToastforSaved() {
    this.toastr.success("Flow Saved");
  }
  showToastforUnsaved() {
    this.toastr.success("Flow Unsaved");
  }

  saveFlow() {
    if (this.userData != null) {
      //
      //this.noResultReturned = true;
      const previousBookmarkColor = this.bookmarkcolor;
      const optimisticSaved = this.bookmarkcolor !== "black";
      this.bookmarkcolor = optimisticSaved ? "black" : "gray";
      this.cdr.detectChanges();

      const flowModel = {
        UserEmail: this.userData.emailAddress,
        FlowId: this.flowData.rowKey,
        FlowType: 1,
      };

      this.flowServiceService.postBookMarkFlow(flowModel).subscribe(
        (data) => {
          //this.noResultReturned = false;
          if (data.bookMarked === "bookmarked") {
            this.bookmarkcolor = "black";
            this.showToastforSaved();
            this.flowData.saveCount = this.flowData.saveCount + 1;
            console.log(this.flowData.saveCount);
          } else if (data.bookMarked === "bookmarkremoved") {
            this.bookmarkcolor = "gray";
            this.showToastforUnsaved();
            this.flowData.saveCount = this.flowData.saveCount - 1;
            console.log(this.flowData.saveCount);
          }
          this.cdr.detectChanges();
        },
        () => {
          this.bookmarkcolor = previousBookmarkColor;
          this.cdr.detectChanges();
        }
      );
    } else {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
  this.authModalService.openModal('registration', this.router.url);
    }
  }

  onChatClick() {
    if (this.userData != null) {
      // localStorage.setItem("flowData", JSON.stringify(this.flowData));
      // this.router.navigate(["/comment"]);
      localStorage.setItem("flowcommentData", JSON.stringify(this.flowData));
      localStorage.removeItem("bundlecommentData");
      const dialogRef = this.dialog.open(CommentComponent, {
        panelClass: "dialoguebox",
        data: {
          openReviewFlow: () => this.openReviewDialog(),
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.getFlowDetails(this.flowData.rowKey);
        this.loadComments(); // Reload comments after dialog closes
      });
    } else {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
  this.authModalService.openModal('registration', this.router.url);
    }
  }

  loadComments() {
    this.comments = [];
    const flowKey = this.flowData?.rowKey ?? this.flowData?.RowKey;
    if (!flowKey) {
      this.cdr.markForCheck();
      return;
    }

    let email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    const flowQueryModel = new FlowQueryModel({
      FlowId: flowKey,
      partitionKey: flowKey,
      userEmail: email,
      pageIndex: 0,
    });

    this.flowServiceService.getUsersFlowComments(flowQueryModel).subscribe({
      next: (data) => {
        const rawList = data?.flowComments ?? data?.FlowComments ?? [];
        this.comments = (Array.isArray(rawList) ? rawList : []).map((element) => {
          const normalized = this.normalizeCommentForUi(element);
          if (
            this.userData &&
            this.userData.emailAddress === normalized.commentedByUserEmail
          ) {
            normalized.isFlowOwner = true;
          }
          return normalized;
        });
        this.cdr.markForCheck();
      },
      error: () => {
        this.comments = [];
        this.cdr.markForCheck();
      },
    });
  }

  openReviewsModal() {
    if (!this.flowData) {
      return;
    }
    this.dialog.open(FlowReviewsListModalComponent, {
      width: "800px",
      maxWidth: "90vw",
      data: { flowData: this.flowData },
      panelClass: "dialoguebox",
    });
  }

  likeComment(comment) {
    if (this.userData != null) {
      const flowModel = {
        PartitionKey: comment.rowKey,
        LikedByUserEmail: this.userData.emailAddress,
        CustomerRowKey: this.userData.rowKey,
      };
      this.flowServiceService.LikeComment(flowModel).subscribe((data) => {
        if (data.isCommentLiked === "liked") {
          comment.isCommentLiked = "liked";
          comment.totalLikedComments = (comment.totalLikedComments || 0) + 1;
        } else if (data.isCommentLiked === "unliked") {
          comment.isCommentLiked = "unliked";
          comment.totalLikedComments = Math.max(
            (comment.totalLikedComments || 0) - 1,
            0
          );
        }
      });
    } else {
  this.authModalService.openModal('registration', this.router.url);
    }
  }

  replyToComment(comment) {
    if (this.previousComment.length > 0) {
      this.previousComment.forEach((element) => {
        element.isReplyClicked = false;
      });
    }
    this.reply = "";
    comment.isReplyClicked = true;
    this.previousComment.push(comment);
  }

  isAddingComment: boolean = false;

  addComment(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Prevent duplicate submissions
    if (this.isAddingComment) {
      return;
    }

    if (
      this.userData != null &&
      !this.flowData.isFlowPurchased &&
      this.flowData.price != null &&
      this.flowData.isPaid &&
      this.userData.emailAddress !== this.flowData.customerEmail
    ) {
      this.toastr.success("To add comment please purchase flow");
      localStorage.setItem("checkoutFlow", JSON.stringify(this.flowData));
      this.router.navigate(["/checkout"]);
      return;
    }

    const commentText = this.commentsForm.get("Comment")?.value;
    if (commentText && commentText.trim().length > 0) {
      this.isAddingComment = true;
      this.noResultReturned = true;
      const commentModel = {
        FlowId: this.flowData.rowKey,
        CommentedByUserEmail: this.userData.emailAddress,
        Comment: commentText.trim(),
        ParentCommentId: null,
      };
      this.flowServiceService.addComment(commentModel).subscribe(
        (data) => {
          this.isAddingComment = false;
          this.noResultReturned = false;
          this.commentsForm.get("Comment")?.setValue("");
          this.toastr.success("Comment added successfully");
          this.loadComments();
        },
        (error) => {
          this.isAddingComment = false;
          this.noResultReturned = false;
        }
      );
    }
  }

  addReply(comment) {
    if (
      this.userData != null &&
      !this.flowData.isFlowPurchased &&
      this.flowData.price != null &&
      this.flowData.isPaid &&
      this.userData.emailAddress !== this.flowData.customerEmail
    ) {
      this.toastr.success("To add comment please purchase flow");
      localStorage.setItem("checkoutFlow", JSON.stringify(this.flowData));
      this.router.navigate(["/checkout"]);
      return;
    }

    if (this.reply.length > 0) {
      comment.isReplyClicked = false;
      this.noResultReturned = true;
      const commentModel = {
        FlowId: this.flowData.rowKey,
        CommentedByUserEmail: this.userData.emailAddress,
        Comment: this.reply,
        ParentCommentId:
          comment.parentCommentId == null
            ? comment.rowKey
            : comment.parentCommentId,
      };
      this.flowServiceService.addComment(commentModel).subscribe((data) => {
        this.noResultReturned = false;
        this.reply = "";
        this.toastr.success("Reply added successfully");
        this.loadComments();
      });
    }
  }

  editComment(comment) {
    this.dataService.changeMessage(comment);
    this.router.navigate(["/edit-comment"]);
  }

  deleteComment(comment) {
    var flowQueryModel = new FlowQueryModel({
      rowKey: comment.rowKey,
    });

    this.noResultReturned = true;
    this.flowServiceService.deleteComment(flowQueryModel).subscribe((data) => {
      this.noResultReturned = false;
      this.toastr.success("Comment deleted successfully");
      this.loadComments();
    });
  }

  getProfilepic(): void {
    if (this.userData != null) {
      this.userserviceService.getProfilepic().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
      });
    }
  }

  showImage(itemCategory, item, index) {
    itemCategory.flowModels.forEach((element) => {
      if (element.arrow !== undefined) {
        element.arrow = false;
      }
    });
    if (!itemCategory.showImg || index !== this.previousIndex) {
      this.currentImage = item.Url;
      this.previousIndex = index;
      itemCategory.showImg = true;
      item.arrow = true;
    } else {
      itemCategory.showImg = false;
      item.arrow = false;
    }
  }

  SignOut() {
    localStorage.setItem("LoggedInUser", null);
    this.userDisplayName = null;
    this.router.navigate(["/"]);
  }

  isImageOrVideo(url) {
    const imageExtensions = [
      "jpeg",
      "jpg",
      "png",
      "gif",
      "jfif",
      "tiff",
      "tif",
      "pdf",
      "bmp",
      "webp",
      "svg",
      "heic",
      "heif",
      "raw",
      "arw",
      "cr2",
      "nef",
      "orf",
      "rw2",
      "dng",
      "psd",
      "ico",
      "exif",
      "pjpeg",
      "ppm",
      "pgm",
      "pbm",
      "pnm",
      "xpm",
      "tga",
      "pcx",
      "jp2",
      "jpx",
      "eps",
      "ai",
    ];
    const videoExtensions = [
      "mp4",
      "mov",
      "wmv",
      "flv",
      "avchd",
      "webm",
      "mkv",
      "vob",
      "ogv",
      "gifv",
      "m4p",
      "m4v",
      "3gp",
      "3g2",
      "amv",
      "nsv",
      "ogg",
      "f4v",
      "f4p",
      "f4a",
      "f4b",
      "avi",
      "mts",
      "m2ts",
      "ts",
      "mpg",
      "mpeg",
      "rm",
      "rmvb",
      "divx",
      "xvid",
      "asf",
      "mxf",
      "dv",
      "h264",
      "h265",
      "vp8",
      "vp9",
      "prores",
      "swf",
      "dat",
      "bik",
      "av1",
      "vro",
      "svi",
    ];

    const lowerUrl = url.toLowerCase();

    if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showimage = true;
    } else if (videoExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showimage = false;
    }
  }

  loadSteps(steps) {
    var stepNo = 0;
    steps.forEach((element) => {
      this.isImageOrVideo(element.url);
      // Map TaggedItems (from API) to taggedItems (for component)
      // Handle both TaggedItems (capital T) and taggedItems (lowercase t) for compatibility
      const taggedItems = element.TaggedItems || element.taggedItems || [];
      
      // Normalize itemKey (capital K) to itemkey (lowercase) in tagged items
      const normalizedTaggedItems = taggedItems.map(item => {
        const normalizedItem = { ...item };
        if (normalizedItem.itemKey && !normalizedItem.itemkey) {
          normalizedItem.itemkey = normalizedItem.itemKey;
        }
        return normalizedItem;
      });
      
      this.dataSourceSteps.push({
        stepNo: stepNo + 1,
        title: element.title,
        url: element.url,
        description: element.description,
        id: element.rowKey,
        ShowImage: this.showimage,
        taggedItems: normalizedTaggedItems, // Include tagged items from backend
      });
      stepNo++;
    });
    console.log(this.dataSourceSteps);
  }

  vidEnded(event) {
    // If autoplay is enabled, go to next step instead of replaying
    if (this.isAutoplayEnabled && !this.isLastSlide) {
      this.NextStep();
      return;
    }

    var playcount = 0;
    var video = this.videoPlayCounter.filter(
      (v) => v.currentSrc == event.target.currentSrc
    );
    if (video != null) {
      playcount = video.length;
    }

    if (playcount < 3) {
      this.videoPlayCounter.push({
        eventobj: event,
        currentSrc: event.target.currentSrc,
        playcount: playcount,
      });
      event.target.play();
    }
  }

  vidfocus(event) {}

  toggleAutoplay(checked?: boolean) {
    if (typeof checked === "boolean") {
      if (this.isAutoplayEnabled === checked) {
        return;
      }
      this.isAutoplayEnabled = checked;
    } else {
      this.isAutoplayEnabled = !this.isAutoplayEnabled;
    }
    if (this.isAutoplayEnabled) {
      this.startAutoplayForCurrentStep();
    } else {
      this.stopAutoplay();
    }

    this.triggerMobileAutoplayTooltip();
  }

  private triggerMobileAutoplayTooltip() {
    if (!this.isMobileView) {
      return;
    }

    // Clear any existing toasts first
    this.toastr.clear();

    // Show toast message instead of tooltip on mobile
    const message = this.isAutoplayEnabled
      ? "Autoplay enabled - Flow will automatically advance to next step"
      : "Autoplay disabled - Flow will not automatically advance";
    
    this.toastr.info(message, "", {
      timeOut: 3000,
      positionClass: "toast-top-center",
    });
  }

  private stopAutoplay() {
    if (this.autoplayTimeout) {
      clearTimeout(this.autoplayTimeout);
      this.autoplayTimeout = null;
    }
  }

  private startAutoplayForCurrentStep() {
    if (!this.isAutoplayEnabled || this.isLastSlide) {
      return;
    }

    // Clear any existing timeout
    this.stopAutoplay();

    // If it's the items page, wait 4 seconds
    if (this.itemsRequired === 1) {
      this.autoplayTimeout = setTimeout(() => {
        if (this.isAutoplayEnabled && !this.isLastSlide) {
          this.NextStep();
        }
      }, 4000);
      return;
    }

    // Check if current step has video or image
    // showVideoOrImage = true means video, false means image
    if (this.showVideoOrImage) {
      // It's a video - wait for video to end (handled in vidEnded)
      // Just ensure the video is playing
      setTimeout(() => {
        const videos = document.querySelectorAll("video.main-video-player");
        if (videos.length > 0) {
          const currentVideo = videos[0] as HTMLVideoElement;
          if (currentVideo) {
            // Check if video is already ended or near end
            if (
              currentVideo.ended ||
              (currentVideo.duration &&
                currentVideo.currentTime >= currentVideo.duration - 0.5)
            ) {
              // Video already ended, go to next step
              if (this.isAutoplayEnabled && !this.isLastSlide) {
                this.NextStep();
              }
            } else if (currentVideo.paused) {
              currentVideo.play().catch(() => {
                // Auto-play was prevented, user interaction required
                // Fallback to timeout after 4 seconds
                this.autoplayTimeout = setTimeout(() => {
                  if (this.isAutoplayEnabled && !this.isLastSlide) {
                    this.NextStep();
                  }
                }, 4000);
              });
            }
          }
        }
      }, 300);
    } else {
      // It's an image - wait 4 seconds then go to next
      this.autoplayTimeout = setTimeout(() => {
        if (this.isAutoplayEnabled && !this.isLastSlide) {
          this.NextStep();
        }
      }, 4000);
    }
  }

  vidplay(event) {
    if (!this.viewUnloaded) {
      var videos = this.videoPlayCounter.filter((v) => v.id == event.target.id);

      if (videos.length > 3) {
        videos.forEach((element) => {
          var obj = this.videoPlayCounter.indexOf(element);

          if (obj > -1) {
            this.videoPlayCounter.splice(obj, 1);
          }
        });
      }
      event.target.play();
    }
  }

  getBundles(pageIndex): void {
    var flowModel = {
      rowKey: this.flowData.rowKey,
      partitionKey: this.flowData.customerEmail,
    };

    this.bundleService
      .getBundlesByFlowId(flowModel, pageIndex)
      .subscribe((data) => {
        console.log(data);
        //this.noResultReturned = false;
        data.forEach((element) => {
          this.tempFlows.push(element);
        });
        this.scheduleRetranslate();
      });
    console.log(this.tempFlows);
    localStorage.setItem("BundleListToShare", this.tempFlows);
  }

  loadEmbeddedInBlogs(): void {
    const rowKey = this.flowData?.rowKey || this.flowData?.RowKey;
    if (!rowKey) {
      this.embeddedInBlogs = [];
      return;
    }

    this.flowServiceService
      .getBlogsByEmbeddedContent("flow", rowKey)
      .subscribe({
        next: (data) => {
          this.embeddedInBlogs = Array.isArray(data) ? data : [];
        },
        error: (err) => {
          console.error("Error loading blogs that embed this flow:", err);
          this.embeddedInBlogs = [];
        },
      });
  }

  getBlogTitleSlug(title: any): string {
    return (title || "").toString().replace(/\s+/g, "-");
  }

  blogClicked(blog: any): void {
    if (!blog) {
      return;
    }
    localStorage.setItem("selectedBlogContent", JSON.stringify(blog));
    this.router.navigate([
      "/blog/" + this.getBlogTitleSlug(blog.title || blog.Title),
    ]);
  }

  onScrollDown() {
    //
    // this.noResultReturned = true;
    this.delay(2000).then(() => {
      this.delayedServiceCall();
    });
  }

  delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  delayedServiceCall() {
    var pageIndex = localStorage.getItem("pageIndex");
    pageIndex = (parseInt(pageIndex) + 1).toString();
    localStorage.setItem("pageIndex", pageIndex);
    this.getBundles(pageIndex);
  }

  private scheduleRetranslate(): void {
    if (this.translationService.getCurrentTranslationLanguage()) {
      setTimeout(() => this.translationService.retranslateForNewContent(), 200);
    }
  }

  flowClicked(flow) {
    localStorage.setItem("notificationflowId", null);
    //localStorage.setItem("flow", JSON.stringify(flow));
    localStorage.removeItem("flow"); //, JSON.stringify(flow));
    localStorage.setItem("navigateTo", "/");

    if (flow.type == "Bundle") {
      //this.isItBundle = true;
      this.router.navigate(["/view-guide-pack/" + flow.rowKey]);
    } else {
      //this.isItBundle = false;
      this.router.navigate([
        `/guide/${this.generateUrlSlug(flow.title)}/${flow.rowKey}`,
      ]);
    }
  }

  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  openImage(Url) {
    localStorage.setItem("itemsRequiredImageToShow", Url);

    this.dialog.open(ShowFlowImageDialogComponent, {});
  }

  resizeSrolling() {
    this.carouselOptions = {
      margin: 20,
      nav: true,
      dots: false,
      pagination: false,
      responsiveClass: true,
      loop: false,
      responsive: {
        0: {
          items: 2,
          nav: true,
        },
        300: {
          items: 2,
          nav: true,
        },
        400: {
          items: 2,
          nav: true,
        },
        550: {
          items: 2,
          nav: true,
        },
        600: {
          items: 2.5,
          nav: true,
        },
        700: {
          items: 3,
          nav: true,
        },
        750: {
          items: 4,
          nav: true,
        },
        800: {
          items: 4,
          nav: true,
        },
        900: {
          items: 5,
          nav: true,
        },
        1000: {
          items: 5,
          nav: true,
          loop: false,
        },

        1100: {
          items: 6,
          nav: true,
          loop: false,
        },

        1200: {
          items: 6,
          nav: true,
          loop: false,
        },
        1300: {
          items: 6,
          nav: true,
          loop: false,
        },
        1400: {
          items: 6,
          nav: true,
          loop: false,
        },
        1500: {
          items: 6,
          nav: true,
          loop: false,
        },
      },
    };
  }

  openForECode(flowData: any) {
    const embedContext = buildEmbedContextFromFlowState(
      this.selectedStepIndex,
      this.itemsRequired
    );
    const dialogRef = this.dialog.open(EmbededComponent, {
      panelClass: "dialoguebox",
      width: "520px",
      maxWidth: "95vw",
      data: {
        contentType: "flow",
        flowData,
        embedContext,
      } as ShareEmbedDialogData,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  private applyEmbedViewFromParams(): void {
    if (!this.embedMode) {
      return;
    }

    const view = this.pendingEmbedView || "full";
    this.embedViewType = view;
    this.isApplyingEmbedView = true;

    switch (view) {
      case "cover":
        this.selectStepAdvanced(-2);
        break;
      case "list":
        this.selectStepAdvanced(-1);
        break;
      case "step": {
        const stepNumber = this.pendingEmbedStep || 1;
        const stepIndex = stepNumber - 1;
        if (
          this.flowData?.steps &&
          stepIndex >= 0 &&
          stepIndex < this.flowData.steps.length
        ) {
          this.selectStepAdvanced(stepIndex);
        } else {
          this.selectStepAdvanced(-2);
        }
        break;
      }
      case "full":
      default:
        if (this.selectedStepIndex === -2 && this.flowData) {
          this.selectStepAdvanced(-2);
        }
        break;
    }

    this.isApplyingEmbedView = false;
    this.cdr.markForCheck();
  }

  GetFlowUserData(): void {
    const flowQueryModel = new UserQueryModel();
    flowQueryModel.userEmail = this.userData?.emailAddress;
    flowQueryModel.otherUserEmail = this.flowData.customerEmail;
    console.log(flowQueryModel);
    if (flowQueryModel.userEmail) {
      this.userserviceService
        .viewUserProfile(flowQueryModel)
        .subscribe((data) => {
          console.log(data);
          this.flowCreatorData = data.userData;
          console.log(this.flowCreatorData);
        });
    }
  }

  stopVideo(index: number) {
    setTimeout(() => {
      const videos = document.querySelectorAll("video");
      if (videos[index]) {
        videos[index].pause();
        videos[index].currentTime = 0; // Reset to the beginning
      }
    }, 100); // Adding a slight delay to ensure panel closing animation is smooth
  }

  playVideo(index: number) {
    setTimeout(() => {
      const videos = document.querySelectorAll("video");
      if (videos[index]) {
        videos[index]
          .play()
          .catch((error) => console.error("Error playing video:", error));
      }
    }, 300); // Adding a slight delay to ensure smooth expansion
  }

  toggleGroup(groupKey: string): void {
    this.expandedGroups[groupKey] = !this.expandedGroups[groupKey]; // Toggle
  }

  startX = -2;
  endX = 0;
  shouldIgnoreSwipe = false;

  // Mobile Touch Events
  onTouchStart(event: TouchEvent) {
    this.startX = event.touches[0].clientX;
    this.startY = event.touches[0].clientY; // Track Y position
    const target = event.target as HTMLElement;
    this.shouldIgnoreSwipe = !!target?.closest('[data-noswipe="true"]');
  }

  onTouchEnd(event: TouchEvent) {
    this.endX = event.changedTouches[0].clientX;
    this.endY = event.changedTouches[0].clientY; // Track Y position
    if (this.shouldIgnoreSwipe) {
      this.resetSwipeTracking();
      return;
    }
    this.handleSwipe();
  }

  // Desktop Mouse Events
  onMouseDown(event: MouseEvent) {
    this.startX = event.clientX;
    this.startY = event.clientY; // Track Y position
    const target = event.target as HTMLElement;
    this.shouldIgnoreSwipe = !!target?.closest('[data-noswipe="true"]');
  }

  onMouseUp(event: MouseEvent) {
    this.endX = event.clientX;
    this.endY = event.clientY; // Track Y position
    if (this.shouldIgnoreSwipe) {
      this.resetSwipeTracking();
      return;
    }
    this.handleSwipe();
  }

  // Handle Swipe Logic
  handleSwipe() {
    if (this.isEmbedNavigationLocked) {
      this.resetSwipeTracking();
      return;
    }

    const deltaX = this.endX - this.startX;
    const deltaY = this.endY - this.startY;

    // Check for horizontal swipe
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 30) {
      if (deltaX < 0 && !this.isLastSlide) {
        console.log("Swiped Right");
        this.NextStep();
      } else if (deltaX > 0 && this.selectedStepIndex !== -2) {
        console.log("Swiped Left");
        this.PreviousStep();
      }
    }

    // Reset coordinates
    this.resetSwipeTracking();
  }

  resetSwipeTracking() {
    this.startX = 0;
    this.startY = 0;
    this.endX = 0;
    this.endY = 0;
    this.shouldIgnoreSwipe = false;
  }

  /**
   * Refresh the transfer ownership status and update the UI accordingly
   * This can be called after certain actions to ensure the UI is up to date
   */
  refreshTransferOwnershipStatus(): void {
    if (
      this.userData &&
      this.flowData &&
      this.userData.emailAddress === this.flowData.customerEmail
    ) {
      this.checkTransferOwnershipOnPageLoad();
    }
  }

  /**
   * Load step bookmarks from backend
   */
  loadStepBookmarks() {
    if (this.userData && this.userData.emailAddress && this.flowData && this.flowData.rowKey) {
      this.flowServiceService.getFlowStepBookmarks(this.flowData.rowKey).subscribe({
        next: (bookmarkList) => {
          if (bookmarkList && Array.isArray(bookmarkList)) {
            this.bookmarkedSteps = new Set(bookmarkList.map((b: any) => b.stepIndex));
            this.cdr.markForCheck();
          }
        },
        error: (error) => {
          console.error('Error loading step bookmarks:', error);
        }
      });
    }
  }

  /**
   * Toggle bookmark for a step
   */
  toggleStepBookmark(stepIndex: number, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (!this.userData || !this.userData.emailAddress) {
      this.toastr.error('Please login to bookmark steps');
      return;
    }

    if (!this.flowData || !this.flowData.rowKey) {
      return;
    }

    const wasBookmarked = this.bookmarkedSteps.has(stepIndex);
    if (wasBookmarked) {
      this.bookmarkedSteps.delete(stepIndex);
    } else {
      this.bookmarkedSteps.add(stepIndex);
    }
    this.cdr.markForCheck();

    const bookmarkModel = {
      UserEmail: this.userData.emailAddress,
      FlowId: this.flowData.rowKey,
      StepIndex: stepIndex
    };

    this.flowServiceService.toggleStepBookmark(bookmarkModel).subscribe({
      next: (response) => {
        if (response?.bookMarked === 'bookmarked') {
          this.bookmarkedSteps.add(stepIndex);
          this.toastr.success('Step bookmarked');
        } else if (response?.bookMarked === 'bookmarkremoved') {
          this.bookmarkedSteps.delete(stepIndex);
          this.toastr.success('Bookmark removed');
        }
        this.cdr.markForCheck();
      },
      error: (error) => {
        if (wasBookmarked) {
          this.bookmarkedSteps.add(stepIndex);
        } else {
          this.bookmarkedSteps.delete(stepIndex);
        }
        this.cdr.markForCheck();
        console.error('Error toggling step bookmark:', error);
        this.toastr.error('Unable to save bookmark');
      }
    });
  }

  /**
   * Check if a step is bookmarked
   */
  isStepBookmarked(stepIndex: number): boolean {
    return this.bookmarkedSteps.has(stepIndex);
  }

  /**
   * Track step visit and save to backend
   */
  trackStepVisit(stepIndex: number) {
    // Mark as visited locally
    this.visitedSteps.add(stepIndex);
    
    // Save to backend if user is logged in
    if (this.userData && this.userData.emailAddress && this.flowData && this.flowData.rowKey) {
      const progressModel = {
        UserEmail: this.userData.emailAddress,
        FlowId: this.flowData.rowKey,
        StepIndex: stepIndex
      };
      
      this.flowServiceService.saveStepProgress(progressModel).subscribe({
        next: (response) => {
          console.log('Step progress saved:', response);
        },
        error: (error) => {
          console.error('Error saving step progress:', error);
        }
      });
    }
  }

  /**
   * Load step progress from backend
   */
  loadStepProgress() {
    if (this.userData && this.userData.emailAddress && this.flowData && this.flowData.rowKey) {
      this.flowServiceService.getFlowStepProgress(this.flowData.rowKey).subscribe({
        next: (progressList) => {
          if (progressList && Array.isArray(progressList)) {
            this.visitedSteps = new Set(progressList.map((p: any) => p.stepIndex));
            console.log('Loaded step progress:', this.visitedSteps);
            // Trigger change detection to update the UI with loaded progress
            this.cdr.markForCheck();
          }
        },
        error: (error) => {
          console.error('Error loading step progress:', error);
        }
      });
    }
  }

  /**
   * Check if a step has been visited
   */
  isStepVisited(stepIndex: number): boolean {
    return this.visitedSteps.has(stepIndex);
  }

  /**
   * Calculate completion percentage based on visited steps
   */
  getCompletionPercentage(): number {
    if (!this.flowData || !this.flowData.steps || this.flowData.steps.length === 0) {
      return 0;
    }
    
    const totalSteps = this.flowData.steps.length;
    const visitedCount = this.visitedSteps.size;
    
    return Math.round((visitedCount / totalSteps) * 100);
  }

  /**
   * Calculate circular progress stroke-dasharray for SVG
   * For radius 45: circumference = 2 * π * 45 ≈ 282.74
   */
  getCircularProgressValue(): string {
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    return `${circumference} ${circumference}`;
  }

  /**
   * Calculate circular progress stroke-dashoffset for SVG
   */
  getCircularProgressOffset(): number {
    const percentage = this.getCompletionPercentage();
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    return circumference - (circumference * percentage / 100);
  }

  /**
   * Get circular progress gradient for conic-gradient
   */
  getCircularProgressGradient(): string {
    const percentage = this.getCompletionPercentage();
    const angle = (percentage / 100) * 360;
    return `conic-gradient(#5ea1d8 0deg ${angle}deg, #e0e0e0 ${angle}deg 360deg)`;
  }

  /**
   * Calculate circular progress stroke-dasharray for reference SVG format
   * For radius 15.9155: circumference ≈ 100
   * Format: "progress, gap" where gap = total - progress
   * This ensures only the completed portion is visible
   */
  getCircularProgressDashArray(): string {
    const percentage = this.getCompletionPercentage();
    const total = 100; // Total circumference
    const progress = (percentage / 100) * total;
    const gap = total - progress; // Gap is the remaining portion
    return `${progress}, ${gap}`;
  }

  getCompletionBarStyle(): { [key: string]: string } {
    return {
      background: "linear-gradient(90deg, #5ea1d8 0%, #6bb3e8 100%)",
    };
  }

  /**
   * Background style for the progress track (the gray/blue part behind the fill).
   * Default: #e0e0e0, on step revisit: #e3f2fd.
   */
  getCompletionTrackStyle(): { [key: string]: string } {
    const trackColor = this.hasRestartedAfterCompletion ? "#e3f2fd" : "#e0e0e0";
    return {
      "background-color": trackColor,
      background: trackColor,
    };
  }

  /**
   * Check if the transfer ownership action should be disabled
   * @returns boolean - true if transfer ownership should be disabled, false otherwise
   */
  isTransferOwnershipDisabled(): boolean {
    return (
      this.hasActiveTransferRequest ||
      !hasContentCreationPlanAccess(this.userData)
    );
  }

   /**
   * Check if flow is completed and show review flow
   */
  checkAndShowRatingDialog() {
    // Only show if user is logged in
    if (!this.userData) {
      return;
    }

    // Check if user has already reviewed this flow (using backend data)
    if (this.hasUserReviewedFlow()) {
      return; // Already reviewed, don't show again
    }

    // Show completion confirmation dialog after a short delay
    setTimeout(() => {
      this.showFlowCompletionFlow();
    }, 1000); // 1 second delay after reaching last step
  }

  /**
   * Show the complete review flow
   */
  showFlowCompletionFlow() {
    // Step 1: Completion confirmation
    const completionDialogRef = this.dialog.open(FlowCompletionConfirmationComponent, {
      width: "500px",
      maxWidth: "90vw",
      data: { flowData: this.flowData },
      disableClose: false,
      panelClass: "dialoguebox",
    });

    completionDialogRef.afterClosed().subscribe((completionResult) => {
      // Handle explicit "stuck" path -> go directly to issue reporting + review
      if (completionResult?.stuck === true) {
        const stepIssuesDialogRef = this.dialog.open(FlowStepIssuesComponent, {
          width: "800px",
          maxWidth: "90vw",
          maxHeight: "90vh",
          data: { flowData: this.flowData },
          panelClass: "dialoguebox",
        });

        stepIssuesDialogRef.afterClosed().subscribe((issuesResult) => {
          if (issuesResult?.issues && issuesResult.issues.length > 0) {
            const reviewDialogRef = this.dialog.open(FlowReviewSubmitComponent, {
              width: "600px",
              maxWidth: "90vw",
              data: { flowData: this.flowData, fromIssue: true },
              panelClass: "dialoguebox",
            });

            reviewDialogRef.afterClosed().subscribe((reviewResult) => {
              if (reviewResult) {
                this.submitFlowReview(true, issuesResult.issues, reviewResult);
              }
            });
          }
        });
        return;
      }

      if (completionResult?.completed === false) {
        // User didn't complete, show thank you message
        this.dialog.open(FlowThankYouComponent, {
          width: "500px",
          maxWidth: "90vw",
          data: { flowData: this.flowData },
          panelClass: "dialoguebox",
        });
        return;
      }

      if (completionResult?.completed === true) {
        // Step 2: Issue check
        const issueCheckDialogRef = this.dialog.open(FlowIssueCheckComponent, {
          width: "500px",
          maxWidth: "90vw",
          data: { flowData: this.flowData },
          panelClass: "dialoguebox",
        });

        issueCheckDialogRef.afterClosed().subscribe((issueResult) => {
          if (issueResult?.hasIssues === true) {
            // Step 3: Step-wise issue reporting
            const stepIssuesDialogRef = this.dialog.open(FlowStepIssuesComponent, {
              width: "800px",
              maxWidth: "90vw",
              maxHeight: "90vh",
              data: { flowData: this.flowData },
              panelClass: "dialoguebox",
            });

            stepIssuesDialogRef.afterClosed().subscribe((issuesResult) => {
              if (issuesResult?.issues && issuesResult.issues.length > 0) {
                // User reported step-wise issues, now require a review as next step
                const reviewDialogRef = this.dialog.open(FlowReviewSubmitComponent, {
                  width: "600px",
                  maxWidth: "90vw",
                  data: { flowData: this.flowData, fromIssue: true },
                  panelClass: "dialoguebox",
                });

                reviewDialogRef.afterClosed().subscribe((reviewResult) => {
                  if (reviewResult) {
                    this.submitFlowReview(true, issuesResult.issues, reviewResult);
                  }
                });
              } else if (issuesResult?.skip === true) {
                // User skipped step-wise issues, go to review submit
                const reviewDialogRef = this.dialog.open(FlowReviewSubmitComponent, {
                  width: "600px",
                  maxWidth: "90vw",
                  data: { flowData: this.flowData },
                  panelClass: "dialoguebox",
                });

                reviewDialogRef.afterClosed().subscribe((reviewResult) => {
                  if (reviewResult) {
                    this.submitFlowReview(false, [], reviewResult);
                  }
                });
              }
            });
          } else if (issueResult?.hasIssues === false) {
            // Step 3: Review submission (no issues)
            const reviewDialogRef = this.dialog.open(FlowReviewSubmitComponent, {
              width: "600px",
              maxWidth: "90vw",
              data: { flowData: this.flowData },
              panelClass: "dialoguebox",
            });

            reviewDialogRef.afterClosed().subscribe((reviewResult) => {
              if (reviewResult) {
                this.submitFlowReview(false, [], reviewResult);
              }
            });
          }
        });
      }
    });
  }

  /**
   * Submit flow review to backend
   */
  submitFlowReview(hasIssues: boolean, issues: any[] = [], reviewData: any = null) {
    const reviewModel = {
      FlowRowKey: this.flowData.rowKey,
      IsCompleted: true,
      HasIssues: hasIssues,
      ReviewText: reviewData?.reviewText || null,
      MediaUrl: reviewData?.mediaUrl || null,
      MediaThumbnailUrl: reviewData?.mediaThumbnailUrl || null,
      IsVideo: reviewData?.isVideo || false,
      Rating: reviewData?.rating || 0,
      CreatedByUserEmail: this.userData.emailAddress,
      Issues: issues,
    };

    this.flowServiceService.createFlowReview(reviewModel).subscribe({
      next: (response) => {
        this.toastr.success("Thank you for your feedback!");
        // Refresh reviews display - backend is now the source of truth
        // This will also update the hasUserReviewed flag
        if (this.flowData?.rowKey) {
          this.loadFlowReviews(this.flowData.rowKey);
        }
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.toastr.error("Error submitting review. Please try again.");
        console.error("Error submitting review:", error);
        this.cdr.markForCheck();
      }
    });
  }

  /**
   * Show all issues reported on this flow in a dialog
   */
  showFlowIssuesDialog(): void {
    if (!this.flowReviews || this.flowReviews.length === 0) {
      this.toastr.info("No reviews found for this guide.");
      return;
    }

    // Collect all issues from all reviews
    const allIssues: any[] = [];
    this.flowReviews.forEach(review => {
      if (review.hasIssues && review.issues && review.issues.length > 0) {
        review.issues.forEach((issue: any) => {
          allIssues.push({
            ...issue,
            reviewId: review.id || review.rowKey,
            reviewRating: review.rating,
            reviewDate: review.createdDate,
            reviewerName: review.createdByUserName || review.createdByFirstName || 'Anonymous',
            reviewerEmail: review.createdByUserEmail || review.createdByEmail,
            reviewText: review.reviewText
          });
        });
      }
    });

    if (allIssues.length === 0) {
      this.toastr.info("No issues have been reported for this guide.");
      return;
    }

    // Open dialog to show all issues
    const issuesDialogRef = this.dialog.open(FlowIssuesDialogComponent, {
      width: "900px",
      maxWidth: "95vw",
      maxHeight: "90vh",
      data: {
        flowData: this.flowData,
        issues: allIssues,
        userData: this.userData,
        isFlowOwner: this.isFlowOwner()
      },
      panelClass: "dialoguebox",
    });

    issuesDialogRef.afterClosed().subscribe((result) => {
      // Refresh reviews if needed (especially if a comment was added)
      if (this.flowData?.rowKey) {
        this.loadFlowReviews(this.flowData.rowKey);
      }
    });
  }

  /**
   * Load flow reviews for display
   * Also checks if the logged-in user has reviewed this flow and sets the flag
   */


   loadFlowReviews(flowId:any) {
  if (!flowId) {
    this.flowReviews = [];
    this._updateCachedReviewValues();
    this.cdr.markForCheck();
    return;
  }

  this.isLoadingReviews = true;
  this.hasUserReviewed = false;
  const email = this.userData?.emailAddress ?? '';

  this.flowServiceService
    .getFlowReviews({ FlowRowKey: flowId })
    .pipe(
      take(1),
      catchError((error) => {
        console.error('Error loading flow reviews:', error);
        this.isLoadingReviews = false;
        this.flowReviews = [];
        this._updateCachedReviewValues();
        this.cdr.markForCheck();
        return of({ reviews: [] });
      })
    )
    .subscribe(async (data: any) => {
      try {
        if (!data) {
          this.flowReviews = [];
          await this._updateCachedReviewValues();
          this.isLoadingReviews = false;
          this.cdr.markForCheck();
          return;
        }

        // Fix: API returns { reviews: [...] }, so extract reviews array
        const reviews = (data.reviews || data || []) as any[];
        this.flowReviews = reviews || [];
        
        // Process reviews asynchronously to avoid blocking
        await this.processReviewsInChunks(reviews, email);
        
        // Ensure change detection is triggered after processing
        this.cdr.markForCheck();
        
      } catch (error) {
        console.error('Error processing flow reviews:', error);
        this.flowReviews = [];
        await this._updateCachedReviewValues();
        this.cdr.markForCheck();
      } finally {
        this.isLoadingReviews = false;
        this.cdr.markForCheck();
      }
    });
}

  private async processReviewsInChunks(reviews: any[], email: string) {
    // Process user review check
    this.hasUserReviewed = email && reviews.length > 0
      ? reviews.some(r => (r.email === email || r.CreatedByUserEmail === email))
      : false;
    
    // Update cache asynchronously
    await this._updateCachedReviewValues();
    
    // Trigger change detection after all updates are complete
    this.cdr.markForCheck();
  }

  private async processReviewsAsync(reviews: any[]) {
    // Break up heavy processing using setTimeout to avoid blocking
    await this.delay(0); // Allow other tasks to run
    
    await this._updateCachedReviewValues();
    
    this.cdr.markForCheck(); // Update view after processing
  }


 

  /**
   * Check if the logged-in user has reviewed this flow based on the reviews from API
   * Sets the hasUserReviewed flag accordingly
   */
  checkIfUserHasReviewed(): void {
    if (!this.userData || !this.flowReviews || this.flowReviews.length === 0) {
      this.hasUserReviewed = false;
      return;
    }
    
    const userEmail = this.userData.emailAddress;
    this.hasUserReviewed = this.flowReviews.some(
      (review: any) => review.CreatedByUserEmail === userEmail
    );
  }

  /**
   * Check if the current logged-in user has already reviewed this flow
   * Returns the flag that was set when reviews were loaded from API
   */
  hasUserReviewedFlow(): boolean {
    return this.hasUserReviewed;
  }

  /**
   * Update cached review values (called when reviews change) - async to prevent blocking
   */
  private async _updateCachedReviewValues(): Promise<void> {
    if (!this.flowReviews || this.flowReviews.length === 0) {
      this.resetCachedValues();
      this.cdr.markForCheck();
      return;
    }

    // Break up heavy calculations to prevent blocking
    await this.calculateRatings();
    await this.delay(0);
    
    await this.calculateReviewCounts();
    await this.delay(0);
    
    await this.calculateTopReviews();
    await this.delay(0);
    
    await this.calculateMediaReviews();
    await this.delay(0);
    
    this.cachedCustomersSaySummary = await this.generateCustomersSaySummaryAsync();
    
    this._reviewsCacheValid = true;
    
    // Trigger change detection after all cached values are updated
    this.cdr.markForCheck();
  }

  private resetCachedValues(): void {
    this._cachedAverageRating = 0;
    this._cachedTotalReviews = 0;
    this._cachedRatingPercentages = {};
    this._cachedTopReviews = [];
    this._reviewsCacheValid = true;
    
    // Update public cached properties
    this.cachedAverageRating = 0;
    this.cachedTotalReviews = 0;
    this.cachedCustomersSaySummary = '';
    this.cachedReviewsWithImages = [];
    this.cachedTopReviews = [];
    
    // Trigger change detection
    this.cdr.markForCheck();
  }

  private async calculateRatings(): Promise<void> {
    const reviewsWithRating = this.flowReviews.filter(r => r.rating && r.rating > 0);
    
    if (reviewsWithRating.length === 0) {
      this._cachedAverageRating = 0;
      this.cachedAverageRating = 0;
    } else {
      const sum = reviewsWithRating.reduce((acc, review) => acc + (review.rating || 0), 0);
      this._cachedAverageRating = Math.round((sum / reviewsWithRating.length) * 10) / 10;
      this.cachedAverageRating = this._cachedAverageRating;
    }
    
    // Calculate rating percentages
    this._cachedRatingPercentages = {};
    if (reviewsWithRating.length > 0) {
      for (let star = 1; star <= 5; star++) {
        const count = reviewsWithRating.filter(r => r.rating === star).length;
        this._cachedRatingPercentages[star] = Math.round((count / reviewsWithRating.length) * 100);
      }
    }
  }

  private async calculateReviewCounts(): Promise<void> {
    this._cachedTotalReviews = this.flowReviews.length;
    this.cachedTotalReviews = this._cachedTotalReviews;
  }

  private async calculateTopReviews(): Promise<void> {
    this._cachedTopReviews = [...this.flowReviews]
      .sort((a, b) => {
        if (b.rating !== a.rating) {
          return (b.rating || 0) - (a.rating || 0);
        }
        const dateA = new Date(a.createdDate || 0).getTime();
        const dateB = new Date(b.createdDate || 0).getTime();
        return dateB - dateA;
      })
      .slice(0, 10);
    this.cachedTopReviews = this._cachedTopReviews;
  }

  private async calculateMediaReviews(): Promise<void> {
    this.cachedReviewsWithImages = this.flowReviews.filter(r => r.mediaUrl && r.mediaUrl.trim() !== '');
  }

  private async generateCustomersSaySummaryAsync(): Promise<string> {
    await this.delay(0);
    return this._generateCustomersSaySummary();
  }

  /**
   * Generate AI summary from reviews (2-3 lines summary) - internal method
   */
  private _generateCustomersSaySummary(): string {
    if (!this.flowReviews || this.flowReviews.length === 0) return '';
    
    const reviewsWithText = this.flowReviews.filter(r => r.reviewText && r.reviewText.trim().length > 0);
    const positiveReviews = this.flowReviews.filter(r => r.rating && r.rating >= 4);
    const negativeReviews = this.flowReviews.filter(r => r.rating && r.rating <= 2);
    const averageRating = this._cachedAverageRating;
    
    // Build a 2-3 line summary
    let summaryLines: string[] = [];
    
    // First line: Overall sentiment and rating
    if (averageRating >= 4) {
      summaryLines.push(`This guide has received excellent feedback with an average rating of ${averageRating.toFixed(1)} stars from ${this.flowReviews.length} reviewer${this.flowReviews.length > 1 ? 's' : ''}.`);
    } else if (averageRating >= 3) {
      summaryLines.push(`This guide has received positive feedback with an average rating of ${averageRating.toFixed(1)} stars from ${this.flowReviews.length} reviewer${this.flowReviews.length > 1 ? 's' : ''}.`);
    } else {
      summaryLines.push(`This guide has received mixed feedback with an average rating of ${averageRating.toFixed(1)} stars from ${this.flowReviews.length} reviewer${this.flowReviews.length > 1 ? 's' : ''}.`);
    }
    
    // Second line: Key themes from reviews
    if (reviewsWithText.length > 0) {
      const helpfulCount = reviewsWithText.filter(r => r.reviewText.toLowerCase().includes('helpful') || r.reviewText.toLowerCase().includes('useful') || r.reviewText.toLowerCase().includes('great')).length;
      const issueCount = reviewsWithText.filter(r => r.reviewText.toLowerCase().includes('issue') || r.reviewText.toLowerCase().includes('problem') || r.reviewText.toLowerCase().includes('difficult')).length;
      
      if (helpfulCount > issueCount && helpfulCount > 0) {
        summaryLines.push(`Reviewers commonly mention that the flow is helpful and easy to follow, with clear instructions and useful guidance.`);
      } else if (issueCount > 0) {
        summaryLines.push(`Some reviewers have noted areas for improvement, while others found the flow valuable for their needs.`);
      }
    }
    
    // Third line: Completion status if available
    const completedCount = this.flowReviews.filter(r => r.isCompleted).length;
    if (completedCount > 0 && completedCount === this.flowReviews.length) {
      summaryLines.push(`All reviewers who provided feedback have successfully completed this guide.`);
    } else if (completedCount > 0) {
      summaryLines.push(`${completedCount} out of ${this.flowReviews.length} reviewers have successfully completed this guide.`);
    }
    
    // Join lines with spaces (not newlines for HTML display)
    return summaryLines.join(' ').trim() || 'Customers have shared their experiences with this guide.';
  }

  /**
   * Calculate average rating from all reviews (returns cached value)
   */
  getAverageRating(): number {
    return this.cachedAverageRating;
  }

  /**
   * Get total number of reviews (returns cached value)
   */
  getTotalReviewsCount(): number {
    return this.cachedTotalReviews;
  }

  /**
   * Get rating distribution percentage for a specific star rating (cached)
   */
  getRatingPercentage(starRating: number): number {
    if (!this._reviewsCacheValid) {
      this._updateCachedReviewValues();
    }
    return this._cachedRatingPercentages[starRating] || 0;
  }

  /**
   * Get count of reviews for a specific star rating
   */
  getRatingCount(starRating: number): number {
    if (!this.flowReviews || this.flowReviews.length === 0) return 0;
    return this.flowReviews.filter(r => r.rating === starRating).length;
  }

  /**
   * Get reviews that have images/videos (returns cached value)
   */
  getReviewsWithImages(): any[] {
    return this.cachedReviewsWithImages;
  }

  /**
   * Get top reviews (sorted by rating, then by date) - returns cached value
   */
  getTopReviews(limit: number = 10): any[] {
    return this.cachedTopReviews.slice(0, limit);
  }

  /**
   * Generate AI summary from reviews (returns cached value)
   */
  getCustomersSaySummary(): string {
    return this.cachedCustomersSaySummary;
  }

  /**
   * TrackBy functions for *ngFor to improve performance
   */
  trackByReviewId(index: number, review: any): any {
    return review.id || review.rowKey || review.createdDate || index;
  }

  trackByCommentId(index: number, comment: any): any {
    return comment.rowKey || comment.id || index;
  }

  trackByStepId(index: number, step: any): any {
    return step.id || step.rowKey || index;
  }

  trackByTagId(index: number, tag: any): any {
    return tag.label || index;
  }

  /**
   * Helper methods for star display
   */
  getStarFill(starIndex: number, rating: number): number {
    if (starIndex <= Math.floor(rating)) {
      return 100; // Fully filled
    } else if (starIndex === Math.ceil(rating) && rating % 1 !== 0) {
      return (rating % 1) * 100; // Partially filled
    }
    return 0; // Empty
  }

  isPartialStar(starIndex: number, rating: number): boolean {
    return starIndex === Math.ceil(rating) && rating % 1 !== 0;
  }

  isFilledStar(starIndex: number, rating: number): boolean {
    return starIndex <= Math.floor(rating);
  }

  /**
   * Get common tags from reviews (simplified - can be enhanced)
   */
  getReviewTags(): { label: string; count: number; sentiment?: 'positive' | 'neutral' | 'negative' }[] {
    if (!this.flowReviews || this.flowReviews.length === 0) return [];
    
    const tags: { [key: string]: { count: number; sentiment: 'positive' | 'neutral' | 'negative' } } = {};
    
    // Count tags based on review content and ratings with sentiment
    this.flowReviews.forEach(review => {
      if (review.rating && review.rating >= 4) {
        if (!tags['Mop quality']) tags['Mop quality'] = { count: 0, sentiment: 'positive' };
        tags['Mop quality'].count++;
      }
      if (review.reviewText) {
        const text = review.reviewText.toLowerCase();
        if (text.includes('easy') || text.includes('simple')) {
          if (!tags['Ease of use']) tags['Ease of use'] = { count: 0, sentiment: 'positive' };
          tags['Ease of use'].count++;
        }
        if (text.includes('works well') || text.includes('effective')) {
          if (!tags['Works well']) tags['Works well'] = { count: 0, sentiment: 'positive' };
          tags['Works well'].count++;
        }
        if (text.includes('clean') || text.includes('cleaning')) {
          if (!tags['Cleaning ability']) tags['Cleaning ability'] = { count: 0, sentiment: 'positive' };
          tags['Cleaning ability'].count++;
        }
        if (text.includes('price') || text.includes('value')) {
          if (!tags['Value for money']) tags['Value for money'] = { count: 0, sentiment: 'neutral' };
          tags['Value for money'].count++;
        }
        if (text.includes('break') || text.includes('broken') || text.includes('issue')) {
          if (!tags['Ease of break-in']) tags['Ease of break-in'] = { count: 0, sentiment: 'negative' };
          tags['Ease of break-in'].count++;
        }
      }
      if (review.mediaUrl) {
        if (!tags['With Media']) tags['With Media'] = { count: 0, sentiment: 'positive' };
        tags['With Media'].count++;
      }
    });
    
    return Object.entries(tags)
      .map(([label, data]) => ({ label, count: data.count, sentiment: data.sentiment }))
      .filter(tag => tag.count > 0)
      .sort((a, b) => b.count - a.count)
      .slice(0, 7);
  }

  /**
   * Open review dialog manually (from review icon)
   */
  openReviewDialog() {
    if (!this.userData) {
      // Open registration modal instead of navigating to page
      this.authModalService.openModal('registration', this.router.url);
      return;
    }

    // Check if already reviewed (using backend data)
    if (this.hasUserReviewedFlow()) {
      this.toastr.info("You have already reviewed this guide");
      return;
    }

    this.showFlowCompletionFlow();
  }

  /**
   * Called when user marks/unmarks a review as helpful. The child (customer-feedback-section) already calls the API and updates the review; we only need to refresh the view.
   */
  markReviewHelpful(review: any) {
    if (!review) return;
    this.cdr.markForCheck();
  }

  /**
   * Report review (placeholder - can be implemented with backend)
   */
  reportReview(review: any) {
    if (!review) {
      return;
    }

    // Check if user is logged in
    const userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (!userData || !userData.emailAddress) {
      this.toastr.error("Please login to report this review");
      return;
    }

    // Check if user has already reported this review
    if (this.flowData?.rowKey && review.rowKey) {
      this.flowServiceService.checkIfUserReportedReview(review.rowKey, this.flowData.rowKey)
        .pipe(take(1))
        .subscribe(
          (response) => {
            if (response && response.hasReported) {
              this.toastr.info("You have already submitted a report for this review.");
              return;
            }

            // User hasn't reported, open the dialog
            const dialogRef = this.dialog.open(ReportReviewDialogComponent, {
              width: "520px",
              maxWidth: "95vw",
              data: {
                review,
                flowData: this.flowData,
              },
              panelClass: "dialoguebox",
            });

            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.toastr.info("Review reported. Thank you for your feedback.");
              }
            });
          },
          (error) => {
            console.error("Error checking if user reported review", error);
            // On error, still allow reporting (fail open)
            const dialogRef = this.dialog.open(ReportReviewDialogComponent, {
              width: "520px",
              maxWidth: "95vw",
              data: {
                review,
                flowData: this.flowData,
              },
              panelClass: "dialoguebox",
            });

            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.toastr.info("Review reported. Thank you for your feedback.");
              }
            });
          }
        );
    } else {
      // If flowData or review rowKey is missing, still allow reporting
      const dialogRef = this.dialog.open(ReportReviewDialogComponent, {
        width: "520px",
        maxWidth: "95vw",
        data: {
          review,
          flowData: this.flowData,
        },
        panelClass: "dialoguebox",
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.toastr.info("Review reported. Thank you for your feedback.");
        }
      });
    }
  }

  /**
   * Filter reviews by rating
   */
  filterByRating(rating: number) {
    // TODO: Implement filtering logic
    this.toastr.info(`Filtering reviews by ${rating} star rating`);
  }

  /**
   * Show reviews info dialog
   */
  showReviewsInfo() {
    // TODO: Show info dialog about how reviews work
    this.toastr.info("Customer reviews help others make informed decisions about flows.");
  }

  /**
   * Filter reviews by tag
   */
  filterByTag(tag: string) {
    // TODO: Implement tag filtering logic
    this.toastr.info(`Filtering by tag: ${tag}`);
  }

  /**
   * Scroll carousel left or right
   */
  scrollCarousel(direction: 'prev' | 'next') {
    // TODO: Implement carousel scrolling
    const carousel = document.querySelector('.carousel-container');
    if (carousel) {
      const scrollAmount = 200;
      carousel.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }
  }

  /**
   * Extract title from review text (first few words)
   */
  getReviewTitle(reviewText: string): string {
    if (!reviewText) return '';
    const words = reviewText.split(' ');
    if (words.length <= 5) return reviewText;
    return words.slice(0, 5).join(' ') + '...';
  }

  getInitials(review: any): string {
    const name = review.createdByUserName || review.createdByFirstName || 'Anonymous';
    if (name === 'Anonymous') return 'A';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  getAvatarColor(review: any): string {
    const colors = [
      '#e0e7ff', '#fce7f3', '#fef3c7', '#d1fae5', '#e0f2fe',
      '#f3e8ff', '#fed7aa', '#fecaca', '#c7d2fe', '#bae6fd'
    ];
    const name = review.createdByUserName || review.createdByFirstName || 'Anonymous';
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  }

  isCurrentUserCoAuthor(): boolean {
    if (!this.userData || !this.flowData) return false;
    const userEmail = (this.userData.emailAddress || '').toLowerCase().trim();

    // Check single co-author email field (case-insensitive)
    const singleEmail = (this.flowData.coAuthorEmail || this.flowData.CoAuthorEmail || '').toLowerCase().trim();
    if (singleEmail && singleEmail === userEmail) return true;

    // Check multi co-author emails field — stored as JSON string array by the API
    const rawEmails = this.flowData.coAuthorEmails || this.flowData.CoAuthorEmails;
    if (rawEmails) {
      let emailList: string[] = [];
      if (Array.isArray(rawEmails)) {
        emailList = rawEmails;
      } else {
        try {
          emailList = JSON.parse(rawEmails);
        } catch {
          emailList = String(rawEmails).split(',');
        }
      }
      return emailList.map((e: string) => e.toLowerCase().trim()).includes(userEmail);
    }
    return false;
  }

  openFlowAnalytics(): void {
    if (!this.userData) {
      this.authModalService.openModal('registration', this.router.url);
      return;
    }
    // The analytics component reads flowData.id, flowData.flowType, flowData.flowName
    // and flowData.viewFlows. Viewflow's flowData uses rowKey as the identifier and
    // may use camelCase/PascalCase variants, so normalise before storing.
    const analyticsData = {
      ...this.flowData,
      id: this.flowData.id || this.flowData.rowKey || '',
      flowType: this.flowData.flowType || this.flowData.FlowType || 'Flow',
      flowName: this.flowData.flowName || this.flowData.title || this.flowData.Title || '',
      viewFlows: this.flowData.viewFlows ?? this.flowData.ViewFlows ?? 0,
    };
    localStorage.setItem('analyticsflow', JSON.stringify(analyticsData));
    const isMobile = window.innerWidth <= 768;
    this.dialog.open(AnalyticsComponent, {
      panelClass: 'analytics-dialog',
      width: isMobile ? '100vw' : '95vw',
      maxWidth: isMobile ? '100vw' : '1200px',
      height: isMobile ? '100vh' : '90vh',
      maxHeight: isMobile ? '100vh' : '90vh',
      disableClose: false,
      autoFocus: true,
      restoreFocus: true,
      hasBackdrop: true,
      backdropClass: 'analytics-backdrop',
      position: isMobile ? { top: '0', left: '0' } : undefined,
    });
  }
}

